export default {
  title: 'PIMIS',
  message: {
    login: 'Login',
    logout: 'Logout'
  },
  login: {
    title: 'Login',
    forgottenPassword: 'Forgotten password',
    loginAdAccount: 'MFIN AD',
    loginStandardAccount: 'Login to service',
    anonymousAccess: 'Anonymous access',
    documentation: 'Documentation',
    modalInfo: 'Due to prolonged inactivity or clearing of local cache, you must log in again',
    registrationDesc: 'If your organization is not registered for the service',
    registrationTitle: 'PIMIS Service'
  },
  documents: {
    download: 'Download document'
  },
  user: {
    username: 'Username',
    password: 'Password',
    confirmPassword: 'Confirm password',
    email: 'E-mail',
    firstTimeLogin: 'First time login',
    passwordForgotten: 'Forgotten password',
    passwordResetLinkSent: 'A password reset link has been sent to your email address',
    welcome: 'Welcome'
  },
  sidebar: {
    dashboard: 'Dashboard',
    administration: 'Administration',
    manageUsers: 'Users',
    viewUsers: 'View users',
    viewUserProfile: 'Profile',
    manageOrganizations: 'Organizations',
    viewOrganizations: 'View organizations',
    createUser: 'Create user',
    registry: 'Code books',
    reports: 'Reports',
    registryOrganizations: 'Organizations',
    subscribe: 'Subscribe to code books',
    createSubscribe: 'Subscription',
    manageSubscribe: 'View',
    manageRoles: 'Manage roles',
    viewRoles: 'View roles',
    createRole: 'Create role',
    projects: 'Projects',
    projectLists: 'Project lists',
    registries: 'Code books',
    createProject: 'Create project',
    viewProjects: 'View projects',
    viewProjectsArchived: 'View archived projects',
    manageProjects: 'Manage projects',
    createProjectList: 'Create project list',
    viewProjectLists: 'View project list',
    manageProjectLists: 'Manage project lists',
    projectDetails: 'Project details',
    projectRevisionDetails: 'Project revision details',
    projectPhases: 'Project phases',
    projectOptions: 'Project options',
    projectDocuments: 'Project documents',
    projectOptionsAppropriations: 'Project appropriations',
    projectOptionsOrganizations: 'Project observers',
    formPifMini: 'PIF mini',
    formPreImplementation: 'Preparation',
    formPlan: 'Plan',
    formQuarterly: 'Quarterly',
    formRationalization: 'Rationalization',
    formCorrection: 'Correction',
    formQuarterlyCorrection: 'Quarterly correction',
    formConclusion: 'Conclusion',
    formEffects: 'Ex-post',
    formIdea: 'Idea',
    formImportant: 'Special',
    formPreparedness: 'Readiness',
    formProjectIdentification: 'CP Proposal',
    viewUserDetails: 'User details',
    viewRoleDetails: 'Role details',
    viewOrganizationDetails: 'Organization details',
    viewProjectListDetails: 'Project list details'
  },
  contextPath: {
    administration: 'Administration',
    organization: 'View organizations',
    table: 'Code book',
    role: 'View roles',
    row: 'Record',
    Demo: 'Demo',
    projects: 'View projects',
    'projects-archived': 'View archived projects',
    'project-lists': 'Project lists',
    project: 'Project details',
    pif: 'PIF',
    unospif: 'Enter PIF',
    odobrenjeop: 'Approve AP',
    ocene: 'Evaluations',
    presel: 'Pre-selection',
    preselrk: 'Pre-selection RC',
    form: 'Form',
    phases: 'Phases',
    stages: 'Stages',
    documents: 'Documents',
    options: 'Options',
    details: 'Details',
    organizations: 'Observers',
    appropriations: 'Appropriations',
    dashboard: 'Dashboard',
    registry: 'Code books',
    150: 'PIF Instructions',
    151: 'PIF 1.5.1',
    152: 'PIF 1.5.2',
    153: 'PIF 1.5.3',
    154: 'PIF 1.5.4',
    155: 'PIF 1.5.5',
    user: 'View users',
    archive: 'Archive project',
    unarchive: 'Unarchive project',
    archiveQuestionTest: 'Confirm project archiving',
    archiveSuccess: 'Project successfully archived',
    archiveError: 'Error archiving project',
    editSuccess: 'Data successfully updated'
  },
  userStatuses: {
    0: 'All',
    1: 'Active',
    2: 'Inactive',
    3: 'Revoked',
    4: 'Deactivated'
  },
  tabulator: {
    ajax: {
      loading: 'Loading',
      error: 'Error'
    },
    groups: {
      item: 'item',
      items: 'items'
    },
    pagination: {
      page_size: 'Rows per page:',
      first: 'First',
      first_title: 'First page',
      last: 'Last',
      last_title: 'Last page',
      prev: 'Previous',
      prev_title: 'Previous page',
      next: 'Next',
      next_title: 'Next page'
    },
    headerFilters: {
      default: 'filter',
      columns: {
        name: 'filter name'
      }
    },
    emptyTable: 'No information',
    totalElements: 'Total rows: '
  },
  markdown: {
    bold: 'Bold',
    italic: 'Italic',
    strikethrough: 'Strikethrough',
    'heading-1': 'Large heading',
    'heading-2': 'Medium heading',
    'heading-3': 'Small heading',
    code: 'Code block',
    quote: 'Quote',
    'unordered-list': 'Bullet list',
    'ordered-list': 'Numbered list',
    link: 'Add link',
    image: 'Add image',
    table: 'Add table',
    'horizontal-rule': 'Add horizontal line',
    preview: 'Preview',
    fullscreen: 'Full screen',
    help: 'Help',
    sideBySide: 'Side by side view',
    column: 'Column',
    text: 'Text'
  },
  roles: {
    Administrator: 'Administrator',
    Operator: 'Service operator',
    Reviewer: 'View all code books',
    Operator_Description: 'Treasury administration operator with authority to create system access for new legal entities/bodies',
    Local_Admin: 'Local administrator',
    Local_Admin_Description: 'Administration of legal entities/bodies',
    Local_User: 'Local user',
    Local_Power_User: 'Local user (CPPZ)',
    Local_Verification_User: 'Local verifier user',
    Local_User_Description: 'Local user of legal entity/body',
    Evaluator: 'Evaluator',
    Evaluator_Description: 'Project evaluator',
    Integration: 'Integration',
    Integration_Description: 'Integration user with authority to update code books',
    Refresh_Token: 'Token refresh',
    Demo: 'Demo code book',
    SourceOfFunding: 'Funding sources code book',
    PaymentCode: 'Payment codes code book',
    Country: 'Countries code book',
    Bank: 'Banks code book',
    Currency: 'Currencies code book',
    Function: 'Functions code book',
    EconomicClassification: 'Economic classifications code book',
    Municipality: 'Municipalities code book',
    BudgetUser: 'Budget users code book'
  },
  claims: {
    Admin: 'Administration',
    Admin_description: 'All system functionalities (administration)',
    Organization_RegistrationResolve: 'Manage organization registration',
    Organization_RegistrationResolve_description: 'Approval and cancellation of organization registration requests (administration)',
    Organization_View: 'View organizations',
    Organization_View_description: 'View organization details (administration)',
    Organization_Manage: 'Update organization',
    Organization_Manage_description: 'Update organization short name (administration)',
    Role_Manage: 'Manage user roles',
    Role_Manage_description: 'Create, edit and delete application roles within own organization',
    Role_View: 'View user roles',
    Role_View_description: 'View application roles within own organization',
    User_Manage: 'Manage users',
    User_Manage_description: 'Create and edit users within own organization',
    User_Review: 'View system users',
    User_Review_description: 'View all system users (administration)',
    User_StatusUpdate: 'Revoke user',
    User_StatusUpdate_description: 'Revoke and reactivate user access rights within own organization',
    User_StatusUpdateAll: 'Block user',
    User_StatusUpdateAll_description: 'Block and reactivate user access rights within the system (administration)',
    User_UpdateAll: 'Update system users',
    User_UpdateAll_description: 'Update system users without the ability to create (administration)',
    User_View: 'View users',
    User_View_description: 'View users within own organization',
    Project_View: 'View project',
    Project_View_description: 'View list and details of projects in accordance with organizational rights',
    Project_Manage: 'Manage project',
    Project_Manage_description: 'Create and edit projects within own organization',
    Form_Manage: 'Update forms',
    Form_Manage_description: 'Update forms within own organization',
    Form_ConfirmationResolve: 'Confirm forms',
    Form_ConfirmationResolve_description: 'Confirm forms within own organization',
    Form_ApprovalResolve: 'Approve forms',
    Form_ApprovalResolve_description: 'Approve all forms in the system (administration)',
    Project_ListManage: 'Update project lists',
    Project_ListManage_description: 'Update project lists in the system (administration)',
    Project_ListView: 'View project lists',
    Project_ListView_description: 'View all project lists in the system (administration)',
    Registry_Manage: 'Update code books',
    Registry_Manage_description: 'Update code books in the system (administration)',
    DMS_Manage: 'Manage project documents',
    DMS_Manage_description: 'Add, delete and edit project documents',
    Form_ImportantManage: 'Update forms of special importance',
    Form_ImportantManage_description: 'Update forms of special importance',
    Project_Idea_Verification: 'Idea consent',
    Project_Idea_Verification_description: 'Gives consent for the idea',
    Project_Idea_Approval: 'Idea approval',
    Project_Idea_Approval_description: 'Gives approval for the idea',
    Project_Idea_Minister_Approval: 'Idea - minister approval',
    Project_Idea_Minister_Approval_description: 'Approves idea as minister',
    Project_Send_Ministry: 'Send to minister',
    Project_Send_Ministry_description: 'Permission to send to minister for confirmation',
    Minister: 'Minister',
    Minister_description: 'Permission to sign as minister',
    Mei_Approval_Comment_Send: 'Send MEI for evaluation',
    Mei_Approval_Comment_Send_description: 'Permission to send MEI for evaluation',
    Mei: 'MEI',
    Mei_description: 'View projects requiring MEI evaluation',
    Send_Request_Change_Form: 'Amendment request',
    Send_Request_Change_Form_description: 'Permission to send a form amendment request'
  },
  general: {
    phone: 'Phone number',
    email: 'Email address',
    supportPhoneNumbers: 'Optional list of support phone numbers',
    supportEmails: 'Optional list of support email addresses',
    enterSupportPhones: 'Enter the list of support phone numbers. The separator can be a comma, semicolon or space, as well as their combination (e.g. 064111111, 064222222).',
    enterSupportEmails: 'Enter the list of support email addresses. The separator can be a comma, semicolon or space, as well as their combination (e.g. mail1@test.rs, mail2@test.rs).',
    changelog: 'Service version information',
    technicalSupport: 'Report a problem',
    undefined: '-',
    filters: 'filters',
    clearAllFilters: 'Clear all',
    details: 'Details'
  },
  bool: {
    yes: 'Yes',
    no: 'No'
  },
  registration: {
    title: 'Organization registration',
    registrationForbidden: 'Organization registration is not allowed at this time',
    legalEntityInfo: 'Organization information',
    legalEntityCheckboxText: 'I am registering as a PRIVATE LEGAL ENTITY',
    budgetUserIdNote: 'Type the first few digits of the JBKJS or the first few characters of the name and the system will display suggestions',
    budgetUserId: 'JBKJS',
    budgetUserIdAsterisk: 'JBKJS*',
    budgetNumberFootnote: '*To be filled in by organizations that have been assigned a JBKJS',
    organizationProjects: 'Projects belonging to the selected organization that are not currently the selected project',
    noOrganizationProjects: 'No projects for the selected organization',
    companyNumber: 'Registration number',
    companyNumberShort: 'RN',
    taxIdNumber: 'TIN',
    treasury: 'Treasury code',
    parentCompany: 'Parent institution',
    companyName: 'Organization name',
    legalEntityName: 'Public enterprise name',
    executionAccount: 'Budget execution account (no spaces or hyphens)',
    executionAccountNoDesc: 'Budget execution account',
    address: 'Registered address',
    postalCode: 'Postal code',
    treasuryBranchInfo: 'Treasury Administration organizational unit information',
    treasuryBranch: 'Organizational unit number',
    treasuryBranchNote: 'type the first few letters of the city/municipality and the system will display suggestions',
    email: 'Email address',
    adminInfo: 'Administrator information',
    name: 'Full name',
    personalIdentityNumber: 'Personal ID number',
    identityNumber: 'ID card number',
    submit: 'Submit registration request',
    infoText: 'After successfully submitting the request, you will receive an email with details of the procedure for completing the registration process',
    registrationSuccess: 'Registration successfully completed',
    registrationSuccessText: 'You have successfully registered for the KIBJLS service',
    registrationSuccessConfirmation: 'Check whether you have received a confirmation email from the PIMIS service. If confirmation has not arrived, write down the information from this notice and download the registration account by clicking the \'Download request\' button',
    registrationLimitExceeded: 'You have exceeded the number of successive registration requests, please wait 10 seconds and try again',
    printRequestForm: 'Download request',
    printForm: 'Download confirmation',
    ouList: 'List of organizational units',
    editRegistration: 'If you wish to edit an already submitted registration, press the <strong>Load registration</strong> button and enter the registration edit token to load the registered data.',
    editRegistrationLine2: 'After entering the changes, save them by pressing the <strong>Submit registration request</strong> button',
    editRegistrationButton: 'Edit registration',
    editRegistrationToken: 'Registration edit token',
    editRegistrationLoad: 'Loading data for editing',
    registrationLoad: 'Load registration',
    registrationRequestLine1: 'Your request has been recorded for JBKJS',
    registrationRequestLine2: 'at Branch',
    registrationRequestLine3: 'Address',
    registrationRequestLine4: 'Phone number',
    registrationRequestId: 'Your request has been recorded under number',
    registrationRequestTreasury: 'at branch',
    registrationRequestDocumentation: 'The documentation you are submitting is listed at the web address',
    copyToClipboard: 'Copy registration edit token',
    createdDate: 'Registration date'
  },
  registry: {
    organizationsDescription: 'Overview of public funds users',
    organizationId: 'JBKJS',
    organizationName: 'Name',
    organizationCompanyNumber: 'RN',
    organizationTaxIdNumber: 'TIN',
    organizationAddress: 'Address',
    organizationPlace: 'Place',
    organizationTreasury: 'Treasury',
    organizationTreasuryBranchCode: 'Treasury branch',
    organizationPhoneNumber: 'Phone number',
    organizationEmail: 'Email',
    organizationActivity: 'Activity',
    organizationType: 'Type'
  },
  profile: {
    details: 'User account details',
    change: 'Edit user account',
    rolesAndClaims: 'User roles and permissions',
    role: 'User role',
    status: 'User status',
    name: 'Full name',
    email: 'Email',
    edit: 'Edit',
    login: 'Username',
    success: 'User information successfully updated',
    successPrivilege: 'User permissions successfully updated',
    description: 'User role description',
    statusRestore: 'User successfully revoked',
    statusActivate: 'User successfully activated',
    revokeDate: 'Date',
    revokeLogin: 'Changed by',
    revokeComment: 'Revocation comment',
    systemRolesAndClaims: 'System privileges',
    dataTablesRolesAndClaims: 'Data table privileges',
    BasicInformation: 'Basic information',
    roles: 'User roles',
    claims: 'User permissions',
    personalSettings: 'Personal settings',
    csvDelimiter: 'CSV delimiter',
    successChangePersonalSettings: 'Personal settings successfully updated',
    loginAd: 'AD user account',
    phoneNumber: 'Phone number'
  },
  successKeyIndicator: {
    ok: 'OK',
    inactivity: 'INACTIVE',
    limitReached: 'OUT OF LIMIT',
    timeToProjectImplementationShortDesc: 'TDR',
    inactivityShortDesc: 'Inactivity',
    fundingAdequacyIndicatorShortDesc: 'FAI',
    calculate: 'Calculate',
    reset: 'Reset'
  },
  status: {
    Active: 'Active',
    Inactive: 'Inactive',
    Revoked: 'Revoked',
    RevokedAccess: 'Revoked access'
  },
  form: {
    date: 'Date',
    ok: 'OK',
    cancel: 'Cancel',
    submit: 'Confirm',
    send: 'Send',
    validate: 'Validate form',
    mark: 'Evaluate',
    markAndLock: 'Evaluate and lock',
    close: 'Close',
    save: 'Save',
    saveAndLock: 'Save and lock',
    lock: 'Lock',
    unlock: 'Unlock',
    apply: 'Apply',
    edit: 'Edit',
    register: 'Register',
    errors: 'Errors',
    warnings: 'Warnings',
    warning: 'Warning',
    notification: 'Notification',
    load: 'Load',
    saveToFile: 'Save to file',
    saveToDiagnosticFile: 'Save to diagnostic file',
    saveToClipboard: 'Save to clipboard',
    capsLockOn: 'CapsLock is on',
    activate: 'Activate',
    approve: 'Approve',
    revoke: 'Revoke',
    saveSubscription: 'Save subscription',
    add: 'Add',
    update: 'Update',
    success: 'Action successfully performed',
    delete: 'Delete',
    export: 'Export',
    exportToCsv: 'Export to CSV',
    exportToJson: 'Export to JSON',
    exportToPdf: 'Export to PDF',
    import: 'Import',
    importJson: 'Import JSON file',
    notChangedForm: 'You must change at least one field',
    sendActivationEmail: 'Send activation email',
    yes: 'Yes',
    no: 'No',
    return: 'Return for revision',
    approvePhase: 'Confirm stage',
    approveQaurter: 'Confirm quarter',
    stopped: 'Rationalization - Closure',
    postponed: 'Rationalization - Postponement',
    correction: 'Correction',
    correctionApproved: 'Correction accepted',
    correctionAmendment: 'Correction amendment',
    addNewQaurter: 'Yes and add new quarter',
    addNewPhase: 'Yes and proceed to next phase',
    validation: 'Validation',
    commissionDecisionDateControlText: 'Enter the commission session date',
    postponedDateControlText: 'Enter the date until which the project is postponed',
    actions: {
      rationalizationProposal: 'Rationalization proposal',
      rationalizationCorrectionProposal: 'Re-correction proposal',
      sendToCommission: 'Send list to commission',
      commissionDecision: 'Commission decision',
      planCorrection: 'Plan correction',
      cancelPreImplementation: 'Cancel project',
      successKeyIndicator: 'KPI',
      idea: 'Send idea to list',
      correction: 'Send correction proposal to list',
      important: 'Project of special importance',
      verificationSend: 'Send for consent',
      verification: 'Consent',
      ministerApprovalSend: 'Send for minister confirmation',
      ministerApproval: 'Minister confirmation',
      meiApprovalCommentSend: 'Send MEI for preliminary evaluation',
      meiApprovalComment: 'Confirm preliminary evaluation',
      returnFormForUpdate: 'Return form for revision',
      sendFormForUpdate: 'Send form amendment request',
      projectIdentification: 'Send project proposal to list',
      preparedness: 'Send project readiness to list',
      ideaCommissionDecision: 'Commission decision for project idea',
      projectIdentificationCommissionDecision: 'Commission decision for project identification',
      preparednessCommissionDecision: 'Commission decision for project readiness',
      correctionCommissionDecision: 'Commission decision for project correction',
      openCorrection: 'Send project for correction',
      updateImportant: 'Update',
      approveImportant: 'Confirm',
      '00': 'Confirm quarter',
      '01': 'Send for approval',
      '012': 'Confirm quarter',
      '02': 'Approve',
      '03': 'Confirm',
      '020': 'Consent',
      '022': 'Confirm',
      11: 'Send for approval',
      12: 'Approve',
      13: 'Confirm',
      21: 'Send for approval',
      22: 'Approve',
      23: 'Confirm',
      31: 'Send for approval',
      32: 'Approve',
      33: 'Confirm',
      312: 'Confirm quarter',
      313: 'Approve quarter',
      41: 'Send for approval',
      42: 'Approve',
      43: 'Confirm',
      51: 'Send for approval',
      52: 'Approve',
      53: 'Confirm',
      61: 'Send for approval',
      62: 'Approve',
      63: 'Confirm',
      71: 'Send for approval',
      72: 'Approve',
      73: 'Confirm',
      81: 'Send for approval',
      82: 'Approve',
      83: 'Confirm',
      512: 'Confirm quarter',
      513: 'Approve quarter',
      111: 'Send for approval',
      112: 'Approve',
      113: 'Confirm',
      1129: 'Send for approval',
      1133: 'Approve',
      1134: 'Confirm',
      121: 'Send for approval',
      122: 'Approve',
      123: 'Confirm'
    },
    importText1: 'The displayed text represents the current form in JSON format.',
    importText2: 'JSON can be edited directly here or replaced by loading a JSON file.',
    name: {
      0: 'Form for preliminary evaluation of project ideas',
      1: 'Form for evaluation of project proposals',
      2: 'Capital project readiness report'
    },
    description: {
      0: `The Form for Preliminary Evaluation of Project Ideas is a form on which the initial proposal for a republican capital project idea is submitted.

The significance of this form lies in identifying the initial idea of a capital project whose realization would, from the perspective of the authorized proposer, bring benefit to the Republic of Serbia, or to one or more units of local self-government (municipality, city or the city of Belgrade).

With the above in mind, when filling in this form it is necessary to clearly define:
 - The name of the project idea;
 - A preliminary estimate of capital project costs (preparation and realization costs);
 - A preliminary estimate of the duration of the capital project (project preparation and project realization);
 - Links to development planning documents, public policy documents and other planning documents;
 - Potential sources of funding (project preparation and realization).

**Note**: When preparing this form it is not necessary for the listed indicators to be definitively identified, as they may change or be supplemented during later preparation of the project idea. The entered data must provide a sufficient level of information about the relevance of the project idea in relation to the aspects defined by Article 13 of the Regulation on Capital Projects so that it can adequately be subject to pre-selection and further evaluation. Particular attention should be paid to the fact that project data may indicate the project's impact on the environment, the project's relationship to and contribution to adaptation or mitigation of changed climatic conditions, all in accordance with applicable international agreements, strategic and other documents and regulations in the field of environmental protection, response to changed climatic conditions, energy and green transition and sustainable economic development, and the relationship to other documents and strategic commitments of the Republic of Serbia that form part of the legal framework in force at the time of submission of this form.

The provisions of the Rulebook on Project Documentation stipulate that the person who is authorized by law and other regulations to represent the Authorized Proposer signs this form and guarantees the accuracy of the data stated therein.`,
      1: `The Form for Evaluation of Project Proposals is a form on which a project proposal is submitted and which is used for analysis of the strategic relevance, financial and implementation aspects of the project proposal.

The significance of this form lies in identifying the project proposal whose realization would, from the perspective of the authorized proposer, bring benefit to the Republic of Serbia, an autonomous province or one or more units of local self-government.

With the above in mind, and in order to precisely identify the project proposal, when filling in this form it is necessary to clearly define the objectives of the project proposal, target groups, anticipated costs, negative impacts, expected results, risks, as well as a platform for mitigating anticipated potential risks.

For projects for which financing or co-financing from European Union funds is planned, the authorized proposer is obliged when submitting this form to also attach the evaluation outcome from ISDAKON.

**Note**: When preparing this form it is not necessary for the listed indicators to be definitively identified, as they may change or be supplemented during project preparation for realization.
Also, the authorized proposer is required when entering data to provide a sufficient level of information about the relevance of the project proposal in relation to the aspects defined by Article 13 of the Regulation on Capital Projects so that it can adequately be subject to further evaluation.
Particular attention should be paid to the fact that project data may indicate the project's impact on the environment, the project's relationship to and contribution to adaptation or mitigation of changed climatic conditions, all in accordance with applicable international agreements, strategic and other documents and regulations in the field of environmental protection, response to changed climatic conditions, energy and green transition and sustainable economic development, and the relationship to other documents and strategic commitments of the Republic of Serbia that form part of the legal framework in force at the time of submission of this form.

Text written in italic font represents instructions for filling in this form, which may be deleted during completion or used to better clarify the project proposal.

The provisions of the Rulebook on Project Documentation stipulate that the person who is authorized by law and other regulations to represent the Authorized Proposer signs this form and guarantees the accuracy of the data stated therein.

The Form for Evaluation of Project Proposals is divided into sections listing:
1. General information and data with a description of the project proposal;
2. Data relevant for determining the acceptability of the project proposal;
3. Data on the relevance of the project proposal;
4. Data on the financial aspect of the project proposal;
5. Data on the implementation aspect of the project proposal.`,
      2: `The Capital Project Readiness Report (hereinafter: the Report) is used to obtain additional information and data in order to determine the level of preparedness of existing project documentation and to assess the project's readiness for financing and realization.

Taking into account the specifics of the particular capital project, all fields in the sections of the Report must be filled in, and documentation must be attached in accordance with the Regulation on Capital Projects.

Fields that do not apply to the Authorized Proposer in the particular case (depending on the nature of the project or for other reasons) are not filled in.

For projects for which financing or co-financing from European Union funds is planned, the authorized proposer is obliged when submitting this form to also attach the evaluation outcome from ISDAKON.

The Report should be completed professionally, responsibly and diligently. The Report should provide an adequate level of information and documentation so that the project can be evaluated and selected based on its relevance to the objectives and aspects defined by the Regulation, particularly in relation to the aspects prescribed by Article 13 of the Regulation. When preparing this Report, particular attention should be paid to ensuring that projects are considered and evaluated in terms of the project's impact on the environment, the project's relationship to and contribution to adaptation or mitigation of changed climatic conditions, in accordance with applicable international agreements, strategic and other documents in the field of environmental protection, response to changed climatic conditions, green transition and other documents and strategic commitments of the Republic of Serbia that form part of the legal framework in force at the time of submission of this Report.

The provisions of the Rulebook on Project Documentation stipulate that the person who is authorized by law and other regulations to represent the Authorized Proposer signs the Report and guarantees the accuracy of the data stated therein.

Text written in italic font represents instructions for filling in this form, which may be deleted during completion or used to better clarify the project proposal.

The Report is divided into sections listing:
1. General data on the project and authorized proposer and project description;
2. Data for project identification;
3. Data on the technical aspect of the project;
4. Data on institutional characteristics and the institutional aspect of the project;
5. Data on the economic-financial aspect of the project;
6. Data relevant for evaluating the project's environmental impact;
7. Data on preliminary project risks;
8. A concise overview/summary of the listed data with the authorized proposer's preliminary assessment of the project's level of readiness.`
    }
  },
  activation: {
    title: 'User activation',
    success: 'User successfully activated',
    activationSent: 'If the username is correct, the user activation link will be sent to your email address'
  },
  reset: {
    title: 'Set password',
    success: 'User password successfully set'
  },
  errors: {
    someErrorsOccuredCheckListBelow: 'An error occurred. Check the error list below',
    missingConclusionReport: 'CP rep.',
    token: {
      refreshTokenExpired: 'Refresh token has expired',
      failedToRefreshToken: 'Error obtaining access token after refresh'
    }
  },
  autocomplete: {
    completeSearchMessage: 'The entered criterion \'{query}\' satisfies more than {limit} results. Narrow the criterion or continue searching at {url}',
    urlText: 'KJS list',
    noItemsFound: 'No results for the given search criteria'
  },
  dropzone: {
    defaultMessage: 'Drag a file into the framed area or click for a dialog',
    allowedFormats: 'Allowed file types: ',
    unsupportedFile: 'File type not allowed!',
    tooManyFiles: 'You have dragged more than the allowed number of files',
    unmatchedClosingTag: 'Missing opening tag',
    unexpectedClosingTag: 'Unexpected closing tag',
    unknownError: 'Unknown error in document'
  },
  userAdministration: {
    description: 'Manage user accounts and security privileges',
    userManagementDescription: 'View and manage existing service users',
    userCreateDescription: 'Add a new user account for working with the service',
    roleManagementDescription: 'View and manage user roles and privileges',
    organizationManagementDescription: 'View and manage organizations, approve and cancel registration requests in the system',
    roleCreateDescription: 'Create a new user role in the system',
    userDetails: 'User account details',
    userLogin: 'Username',
    userLoginAd: 'AD user account',
    userName: 'Full name',
    userStatus: 'User status',
    email: 'Email',
    name: 'Name',
    organizationName: 'Organization',
    administration: 'User management',
    localAdministration: 'Local user management',
    localUserRoles: 'User roles',
    localUserClaims: 'User permissions',
    roleClaims: 'Role user permissions',
    apply: 'Apply',
    userCreateConfirmation: 'Create new local user?',
    userGroupCreateConfirmation: 'Do you want to create a new user group?',
    createUserSuccessful: 'User successfully created',
    profileEditPrompt: 'Are you sure you want to edit user information?',
    permissionEditPrompt: 'Are you sure you want to edit user permissions and roles?',
    revokePromptTitle: 'Are you sure you want to revoke the user?',
    revokePromptPlaceholder: 'Enter revocation comment',
    activatePrompt: 'Are you sure you want to activate the user?',
    activateTitle: 'User activation',
    userPasswordRequirement: {
      0: 'Password character count is incorrect',
      1: 'Password must contain numbers',
      2: 'Password must contain uppercase letters',
      3: 'Password must contain symbols'
    },
    userLoginRequirement: {
      0: 'User account may contain Latin letters of the English alphabet',
      1: 'User account may contain numbers',
      2: "User account may contain symbols '.' , '_'",
      3: 'User account must start and end with a letter or number',
      4: 'User account may contain a maximum of 32 characters'
    },
    changePassword: 'Change password',
    changePersonalInformation: 'Change personal information',
    personalInformation: 'Personal information',
    oldPassword: 'Old password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    password: 'Password',
    confirmPassword: 'Confirm password',
    confirmPasswordFail: 'New password does not match the password confirmation',
    passwordChanged: 'New password successfully set',
    createUserPrompt: 'Are you sure you want to create the user?',
    createRolePrompt: 'Are you sure you want to create the role?',
    profile: 'Profile',
    InfoNotSet: 'You have not entered user data',
    userInformationUpdateSuccess: 'User information successfully updated',
    userRole: 'User role',
    userRoleId: 'Role identifier',
    userRoleName: 'Role name',
    userRoleDescription: 'Role description',
    userRoleCreatedDate: 'Creation date',
    userRoleType: 'Role type',
    userRoleOrganization: 'Organization',
    lastLoginDate: 'Last login',
    createRoleSuccessful: 'User role successfully created',
    changeRoleDetails: 'Change role details',
    changeRoleClaims: 'Change role user permissions',
    deleteRoleTitle: 'Delete user role',
    deleteRoleMessage: 'Are you sure you want to delete the user role?',
    updateRoleSuccessful: 'Role successfully updated',
    deleteRoleSuccessful: 'Role successfully deleted',
    notifyUser: 'Notify user about created user account',
    additionalSettings: 'Additional settings',
    userRoleInformation: 'Basic role information',
    userInformation: 'Basic user information',
    revokeText: 'After revocation the user will no longer be able to log in to the system'
  },
  organizationAdministration: {
    name: 'Name',
    nameShort: 'Short name',
    budgetUserId: 'JBKJS',
    registrationDate: 'Registration date',
    legalEntityInfo: 'Organization information',
    adminName: 'Full name',
    adminLogin: 'Administrator username',
    adminLoginHint: 'Enter username and wait for verification',
    status: 'Status',
    registrationId: 'Request number',
    registrationFormTitle: 'Registration request',
    printAdminFormTitle: 'User account receipt confirmation',
    registrationToken: 'Registration edit token',
    companyNumber: 'Registration number',
    companyNumberShort: 'RN',
    taxIdNumber: 'TIN',
    treasury: 'Treasury code',
    parentCompany: 'Parent institution',
    companyName: 'Organization name',
    legalEntityName: 'Public enterprise name',
    executionAccount: 'Budget execution account (no spaces or hyphens)',
    executionAccountNoDesc: 'Budget execution account',
    address: 'Registered address',
    postalCode: 'Postal code',
    treasuryBranchInfo: 'Treasury Administration organizational unit information',
    treasuryBranch: 'Organizational unit number',
    treasuryBranchNote: 'type the first few letters of the city/municipality and the system will display suggestions',
    email: 'Email address',
    adminInfo: 'Administrator information',
    identityNumber: 'ID card number',
    approvedUser: 'User who approved the account',
    approvedDate: 'Approval date',
    cancelledUser: 'User who rejected the account',
    cancelledDate: 'Rejection date',
    approvalSuccessful: 'Organization successfully approved',
    updateSuccessful: 'Organization successfully updated',
    cancellationSuccessful: 'Organization successfully rejected',
    statuses: {
      1: 'Pending',
      2: 'Approved',
      3: 'Rejected'
    },
    statusNames: {
      PENDING: 'Pending',
      APPROVED: 'Approved',
      CANCELLED: 'Rejected'
    },
    adminLoginRequirement: {
      0: 'Username may contain Latin letters of the English alphabet',
      1: 'Username may contain numbers',
      2: "Username may contain symbols '.' , '_'",
      3: 'Username must start and end with a letter or number',
      4: 'Username may contain a maximum of 32 characters'
    },
    printRegistration: 'Download request',
    printAdminForm: 'User account receipt confirmation'
  },
  appropriations: {
    budgetYear: 'Budget year',
    organizationCode: 'JBKJS',
    budgetYearShort: 'Year',
    program: 'Program',
    project: 'Project',
    positionChapter: 'Chapter',
    positionSubchapter: 'Sub-chapter',
    economicClassification: 'Account',
    sourceOfFunding: 'Source',
    function: 'Function',
    amount: 'Amount',
    currentAmount: 'Current amount',
    setAppropriationsSuccessful: 'Appropriations successfully updated',
    setAppropriationsWarning: 'Update not performed as there were no changes',
    showSelected: 'Show selected',
    showAll: 'Show all'
  },
  reports: {
    projectsByPhase: 'By phases',
    projectsByPhaseDescription: 'Distribution of CPs by AP and by phases',
    projectsByOrganization: 'By authorized proposers',
    projectsByOrganizationDescription: 'Estimated value of CPs by AP',
    importantProjects: 'Capital projects',
    importantProjectsDescription: 'Capital projects of special importance',
    reportsTitle: 'Reports',
    reportsDescription: 'Reports overview',
    projectListReportTitle: 'Project List',
    projectListReportDescription: 'List of projects by authorized proposer',
    projectSummaryReportTitle: 'Summary Overview',
    projectSummaryReportDescription: 'Summary overview of CPs by proposer',
    projectsRealizedReportTitle: 'Realized',
    projectsRealizedReportDescription: 'Realized projects',
    projectsInRealizationReportTitle: 'In realization',
    projectsInRealizationReportDescription: 'Projects in realization',
    projectsAllReportTitle: 'All',
    projectsAllReportDescription: 'All projects in the system',
    projectsMeiExport: 'Export list to XLS',
    projectsExport: 'Export list to XLS',
    projectsExportAtDay: 'Export list to XLS as of date',
    projectsBoardAccepted: 'Accepted by commission',
    rojectsBoardAcceptedDescription: 'All projects accepted by the commission'
  },
  projects: {
    tabs: {
      details: 'Details',
      stages: 'Stages',
      documents: 'Documents',
      options: 'Options',
      forms: 'Forms',
      activities: 'Activities',
      organizations: 'Observers',
      appropriations: 'Appropriations',
      history: 'History',
      settings: 'Settings',
      merging: 'Linking',
      lists: 'Lists'
    },
    listTypes: {
      1: 'Rationalization proposal',
      2: 'Rationalization',
      3: 'Idea',
      4: 'CP Proposal',
      5: 'Readiness',
      6: 'Correction'
    },
    notOnList: '(Project is not on the list)',
    noMfinComment: '(MF comment not entered)',
    noMfinCommentDialog: 'MF comment not entered',
    commissionDecisionModalText: 'Has the commission decided that the project moves to the next phase? If yes, it proceeds to the next phase. If no, the project goes into dormancy.',
    downloadList: 'Download list',
    downloadConfirmedList: 'Download adopted list',
    changedValue: 'Changed value',
    export: 'Export project',
    exportId: 'Project ID card',
    sendListPrompt: 'Are you sure you want to create the list?',
    createRationalizationList: 'Create rationalization project list',
    createProposalRationalizationList: 'Create rationalization project list',
    createProjectIdentificationList: 'Create proposed list of projects in preparation',
    createIdeaList: 'Create proposed unified list of project ideas',
    createPreparednessList: 'Create proposed list of prepared projects',
    createCorrectionList: 'Create correction project list',
    createImportantList: 'Create list of projects of special importance',
    sendListSuccessful: 'List successfully sent to commission',
    historyLists: 'Historical lists',
    listName: 'Name',
    menuDescription: 'Create new project, view and manage existing projects',
    projectsArchiveTitle: 'Archive',
    projectsArchiveDescription: 'Archived projects',
    listMenuDescription: 'Create project list, view and manage project lists',
    registryMenuDescription: 'View code books',
    projectManagementDescription: 'View and manage existing capital projects',
    projectCreateDescription: 'After successfully creating the project you will be redirected to the details page of the new project',
    project: 'Project',
    viewProjects: 'View projects',
    viewProjectsArchived: 'View archived projects',
    createProject: 'Create project',
    name: 'Project name',
    number: 'Identifier',
    code: 'Working name',
    important: 'Project of special importance',
    projectStage: 'Stage',
    codeInfo: 'Short working name of the project',
    codeInfoDesc: 'Must contain between 3 and 20 characters. Only English Latin letters, numbers and characters _ and - are allowed',
    codeUpdateInfoDesc: 'Changing the working name changes the browser link (URL) to the PIMIS project.',
    codeUpdateInfoDesc2: 'After the change, existing links will stop working, whether used outside or within the PIMIS system',
    codeUpdateWarning: 'Warning',
    nameInfoDesc: 'The name value defined in options takes precedence over the value defined in the form. Setting an empty value in options takes the value from the form',
    importantInfoDesc: 'The project of special importance value defined in options takes precedence over the value defined in the form. Setting an empty value in options takes the value from the form',
    updateCode: 'Change working name',
    draftName: 'Project draft name',
    description: 'Project description',
    draftDescription: 'Project draft description',
    organization: 'Organization',
    officalProposerOrganization: 'Authorized proposer',
    proposerOrganization: 'Project proposer',
    notDefinedNameAndDesc: 'Project name and description have not yet been entered in the PIF form',
    notDefinedData: 'Not defined',
    type: 'Project type',
    sector: 'Sector',
    status: 'Project status',
    phase: 'Phase',
    phasePreparation: 'Preparation',
    phaseRealization: 'Realization',
    phaseFinished: 'Completed',
    stage: 'Stage',
    phаseStatus: 'Stage status',
    lastReporting: 'Last quarter',
    estimateTotal: 'Estimated value',
    totalValue: 'Total value',
    count: 'Number of projects',
    createdUser: 'Created by',
    createdDate: 'Creation date',
    changedDate: 'Activity date',
    changedUser: 'Conducted by',
    startedDate: 'Start',
    endedDate: 'End',
    lastChangedDate: 'Last activity',
    submitFormPrompt: 'Are you sure you want to lock the form with warnings?',
    deleteOrganizationPrompt: 'Are you sure you want to disable access for the organization?',
    deleteOrganizationPermission: 'You do not have permission to change organization access',
    createProjectTitle: 'Project confirmation',
    createProjectPrompt: 'Are you sure you want to create the project?',
    createProjectSuccessful: 'Project successfully created',
    updateProjectSuccessful: 'Project successfully updated',
    submitProjectFormInputSuccessful: 'Project form successfully updated',
    submitProjectFormInputSuccessfulWithErrorsAndWarnings: 'Project form successfully updated. There are certain errors and warnings which you can view at the bottom of the screen in the Validations section',
    submitProjectFormInputSuccessfulWithErrors: 'Project form successfully updated. There are certain errors which you can view at the bottom of the screen in the Validations section',
    submitProjectFormInputSuccessfulWithWarnings: 'Project form successfully updated. There are certain warnings which you can view at the bottom of the screen in the Validations section',
    submitProjectFormInputWarning: 'There were no changes on the form so the update was not performed',
    submitProjectFormInputError: 'Form cannot be locked because there are errors. You can view the details at the bottom of the screen in the Validations section',
    markProjectFormInputSuccessful: 'Project form successfully evaluated',
    projectInformation: 'Basic project information',
    projectNoInformation: 'No information',
    projectDraftInformation: 'Basic project draft information',
    projectOfficialProposer: 'Authorized proposer of capital project',
    projectProposer: 'Capital project idea proposer',
    pifForm15: 'PIF Form 1.5',
    pifForm150: 'Instructions for completion',
    pifForm151: 'Section 1',
    pifForm152: 'Section 2',
    pifForm153: 'Section 3',
    pifForm154: 'Section 4',
    pifForm155: 'Section 5',
    pifFormTitle150: 'PIF 1.5 instructions',
    pifFormTitle151: 'PIF 1.5.1',
    pifFormTitle152: 'PIF 1.5.2',
    pifFormTitle153: 'PIF 1.5.3',
    pifFormTitle154: 'PIF 1.5.4',
    pifFormTitle155: 'PIF 1.5.5',
    phaseDetails: 'Selected phase details',
    lockForm: 'Lock form',
    fileUploadSection: 'Project documents',
    formLocked: 'Locked',
    formValid: 'Verified',
    organziationAdd: 'Add organization',
    fileAdd: 'Add',
    fileUpload: 'Save',
    cancelFileUpload: 'Cancel',
    errorPanelHeader: 'Error list',
    optionsDescription: 'Project options allow explicit assignment of project access to other organizations as well as project detail settings',
    sendToListDescription: 'Within a project of special importance, you have the option to select which lists you want this project to appear on.',
    mergingProjectDescription: 'Merging the project with an existing project.',
    foreignFunds: 'EU funded',
    document: {
      name: 'Name',
      revision: 'Revision',
      description: 'Description',
      comment: 'Comment',
      add: 'New document',
      revisionAdd: 'New revision',
      descriptionText: 'Select files to include in the project. Maximum document size is ',
      warning: 'In case of a large number of files or a poor internet connection, sending files may take some time',
      descriptionEmpty: 'Description is required',
      sizeLimitReached: 'File size limit is ',
      countLimitReached: 'File count limit is ',
      extensionInvalid: 'Document type is not allowed',
      linkCopied: 'Link copied - ',
      createdDate: 'Creation date',
      hash: 'Hash',
      size: 'Size',
      extension: 'Extension',
      revisions: 'Document revisions',
      revisionsCount: 'Number of revisions',
      downloads: 'Downloads',
      user: 'User',
      firstDownloadDate: 'First download date',
      lastDownloadDate: 'Last download date',
      actions: 'Actions',
      download: 'Download',
      delete: 'Delete',
      linkCopy: 'Copy link',
      linkOptions: 'Link options',
      back: 'Back',
      deletePrompt: 'Are you sure you want to delete the document?',
      editPrompt: 'Edit document attributes',
      exportAll: 'Download all documents',
      addDocumentTitle: 'Add new document',
      addRevisionTitle: 'Add new revision',
      secured: 'Secured',
      securedDescription: 'Document download requires PIMIS service authorization and authentication',
      public: 'Public',
      publicDescription: 'The document can be downloaded by anyone via the internet if they have this link',
      anonymous: 'Anonymous user',
      error: 'Error',
      type: 'Document type',
      documentType: 'Document type',
      types: {
        0: 'Other',
        1: 'Idea - financing',
        2: 'Idea - strategy',
        3: 'CP Proposal - ISDAKON',
        4: 'CP Proposal - environment',
        5: 'Readiness - ISDAKON',
        6: 'Readiness - studies',
        7: 'Readiness - report',
        8: 'CPPZ - decision - Government of RS',
        9: 'CP Proposal - Letter of intent',
        10: 'CP Proposal - Email exchange',
        11: 'CP Proposal - Letter of intent of external financier',
        12: 'CP Proposal - Display of sources for estimating total capital project costs',
        13: 'Correction - Explanation of deviation reasons',
        14: 'Correction - Evidence of claims',
        15: 'CP completion - Report',
        16: 'Rationalization - Closure report',
        17: 'Rationalization - Closure decision',
        18: 'Rationalization - Postponement decision',
        19: 'Readiness - Framework implementation plan'
      }
    },
    commentRequired: 'Comment is required',
    dateValid: 'Date is required',
    invokeActionPrompt: 'Do you want to confirm the selected action?',
    invokeRationalizationProposalActionPrompt: 'Is the project for rationalization?',
    invokeRationalizationActionPrompt: 'Select commission decision',
    invokeActionSuccessful: 'Action successfully performed',
    invokeCorrectionActionPrompt: 'Confirm sending project for correction',
    jsonDataChange: 'Direct data editing',
    actions: 'Actions',
    forms: 'Forms',
    form: 'form',
    formMinipif: 'pif-mini',
    formPreImplementation: 'preparation',
    formPlan: 'plan',
    comment: 'Comment',
    timeToProjectImplementation: 'TDR',
    inactivity: 'Inactivity',
    fundingAdequacyIndicator: 'FAI',
    showFinished: 'Show completed',
    addOrganization: 'Add user',
    types: {
      1: 'Project in realization',
      2: 'Project in preparation',
      3: 'New realization'
    },
    sectors: {
      1: 'Universal',
      2: 'Transport',
      3: 'Energy',
      4: 'Environment - waste management',
      5: 'Environment - water management',
      6: 'Business competitiveness'
    },
    stages: {
      0: 'Idea',
      1: 'CP Proposal',
      2: 'Readiness',
      3: 'CPPZ',
      4: 'Plan',
      5: 'Reporting',
      7: 'CP completion',
      8: 'Ex-post',
      11: 'Correction',
      12: 'Correction reporting',
      13: 'Rationalization'
    },
    statuses: {
      0: 'In progress',
      1: 'Completed'
    },
    phaseStatuses: {
      1: 'Entry',
      99: 'Returned for revision',
      2: 'Awaiting approval',
      3: 'Awaiting receipt confirmation',
      4: 'Receipt confirmed',
      5: 'Rationalization proposal',
      6: 'Awaiting commission decision',
      7: 'Correction',
      8: 'Postponed',
      9: 'Closed',
      10: 'Rationalization accepted',
      11: 'Cancelled',
      12: 'Awaiting quarter confirmation',
      13: 'Awaiting quarter approval',
      14: 'Awaiting addition to list',
      15: 'Awaiting CP proposal project approval',
      16: 'Awaiting readiness approval',
      17: 'Special importance',
      18: 'Dormancy',
      19: 'Send for consent',
      20: 'Awaiting consent',
      21: 'Send for minister confirmation',
      22: 'Awaiting minister confirmation',
      23: 'Awaiting sending for MEI evaluation',
      24: 'Awaiting MEI evaluation confirmation',
      25: 'Form amendment request sent',
      26: 'Sent for correction',
      27: 'Correction confirmed',
      28: 'Awaiting addition to list',
      29: 'Correction - amendment',
      30: 'Rationalization - postponement',
      31: 'Rationalization - closure',
      32: 'Sent for rationalization',
      33: 'Correction amendment - awaiting amendment approval',
      34: 'Correction amendment - awaiting receipt confirmation'
    },
    projectStages: {
      1: 'Preparation',
      2: 'Realization',
      3: 'Idea',
      4: 'CP Proposal',
      5: 'Readiness'
    },
    activities: {
      '011': 'Idea - Form entry',
      '012': 'Idea - Sent for approval',
      '021': 'Idea - Rejected from approval',
      '023': 'Idea - Approved',
      '031': 'Idea - Rejected from confirmation',
      '034': 'Idea - Confirmed',
      '0414': 'Idea - Sent to list',
      '0146': 'Idea - Awaiting commission decision',
      '064': 'Idea - Commission approved',
      '01919': 'Idea - Send for verification',
      '02019': 'Idea - Rejected from verification',
      '01920': 'Idea - Verification',
      '0201': 'Idea - Send for approval',
      '0221': 'Idea - Approval',
      '0223': 'Idea - Minister approved',
      '02122': 'Idea - Sending to minister for approval',
      '02223': 'Confirmed by minister',
      '02324': 'Sent to MEI for evaluation',
      '0243': 'Confirmed for sending to MFIN',
      '041': 'Idea form returned for revision',
      '0425': 'Idea - Form amendment request sent',
      '0251': 'Idea - Form returned for amendment',
      141: 'CP Proposal form returned for revision',
      110: 'CP Proposal - Form entry',
      111: 'CP Proposal - Form entry',
      112: 'CP Proposal - Sent for approval',
      121: 'CP Proposal - Rejected from approval',
      123: 'CP Proposal - Approved',
      131: 'CP Proposal - Rejected from confirmation',
      134: 'CP Proposal - Confirmed',
      1415: 'CP Proposal - Sent to list',
      1156: 'CP Proposal - Awaiting commission decision',
      1425: 'CP Proposal - Form amendment request sent',
      1251: 'CP Proposal - Form returned for amendment',
      164: 'CP Proposal - Commission approved',
      211: 'Readiness - Form entry',
      212: 'Readiness - Sent for approval',
      221: 'Readiness - Rejected from approval',
      223: 'Readiness - Approved',
      231: 'Readiness - Rejected from confirmation',
      234: 'Readiness - Confirmed',
      2166: 'Readiness - Sent to list',
      241: 'Returned for revision by MFIN',
      2416: 'Readiness - Awaiting commission decision',
      264: 'Readiness - Commission approved',
      2425: 'Readiness - Form amendment request sent',
      2251: 'Readiness - Form returned for amendment',
      364: 'CPPZ - Commission approved',
      311: 'CPPZ - Form entry',
      312: 'CPPZ - Sent for approval',
      321: 'CPPZ - Rejected from approval',
      323: 'CPPZ - Approved',
      331: 'CPPZ - Rejected from confirmation',
      334: 'CPPZ - Confirmed',
      464: 'Plan - Commission approved',
      411: 'Plan - Form entry',
      412: 'Plan - Sent for approval',
      421: 'Plan - Rejected from approval',
      423: 'Plan - Approved',
      431: 'Plan - Rejected from confirmation',
      434: 'Plan - Confirmed',
      564: 'Reporting - Commission approved',
      511: 'Reporting - Form entry',
      512: 'Reporting - Sent for approval',
      521: 'Reporting - Rejected from approval',
      523: 'Reporting - Approved',
      531: 'Reporting - Rejected from confirmation',
      534: 'Reporting - Confirmed',
      517: 'Reporting - Correction',
      561: 'Reporting - Rationalization proposal rejected by commission',
      556: 'Reporting - Rationalization proposal sent to commission',
      515: 'Reporting - Sent for rationalization proposal',
      51212: 'Reporting - Quarter confirmation rejected',
      5112: 'Reporting - Quarter confirmed',
      512131: 'Reporting - Quarter approved',
      5131: 'Reporting - Quarter rejected',
      5134: 'Reporting - Quarter approved',
      5126: 'Reporting - Sent for correction',
      5326: 'Reporting - Sent for correction',
      664: 'Rationalization - Commission approved',
      611: 'Rationalization - Form entry',
      612: 'Rationalization - Sent for approval',
      621: 'Rationalization - Rejected from approval',
      623: 'Rationalization - Approved',
      631: 'Rationalization - Rejected from confirmation',
      634: 'Rationalization - Confirmed',
      646: 'Rationalization - Sent to rationalization commission',
      667: 'Rationalization - Correction',
      668: 'Rationalization - Postponement',
      669: 'Rationalization - Closed',
      711: 'Conclusion - Form entry',
      712: 'Conclusion - Sent for approval',
      721: 'Conclusion - Rejected from approval',
      723: 'Conclusion - Approved',
      731: 'Conclusion - Rejected from confirmation',
      734: 'Conclusion - Confirmed',
      811: 'Ex-post - Form entry',
      812: 'Ex-post - Sent for approval',
      821: 'Ex-post - Rejected from approval',
      823: 'Ex-post - Approved',
      831: 'Ex-post - Rejected from confirmation',
      834: 'Ex-post - Confirmed',
      '0112': 'Sent for quarter confirmation',
      '0123': 'Sent for approval',
      '01211': 'Quarter confirmed',
      '01212': 'Quarter rejected',
      '0121': 'Rejected from confirmation',
      '0111': 'Preparation cancelled',
      '0211': 'Preparation cancelled',
      '0311': 'Preparation cancelled',
      3112: 'Sent for quarter confirmation',
      31212: 'Quarter rejected',
      312131: 'Sent for quarter approval',
      312132: 'Quarter rejected',
      3131: 'Quarter rejected',
      3134: 'Quarter approved',
      3135: 'Proposed for rationalization',
      3125: 'Proposed for rationalization',
      315: 'Proposed for rationalization',
      325: 'Proposed for rationalization',
      335: 'Proposed for rationalization',
      345: 'Proposed for rationalization',
      356: 'Sent to commission for decision',
      361: 'Rationalization proposal rejected',
      362: 'Rationalization proposal rejected',
      363: 'Rationalization proposal rejected',
      3612: 'Rationalization proposal rejected',
      3613: 'Rationalization proposal rejected',
      366: 'Rationalization accepted',
      3610: 'Rationalization accepted',
      317: 'Correction',
      327: 'Correction',
      337: 'Correction',
      347: 'Correction',
      3127: 'Correction',
      3137: 'Correction',
      446: 'Sent to commission for decision',
      467: 'Correction',
      468: 'Postponed',
      469: 'Closed',
      1111: 'Correction - Form entry',
      1112: 'Correction - Sent for approval',
      1123: 'Correction - Approved',
      1134: 'Correction - Confirmed',
      1166: 'Correction - Project added to commission list',
      113329: 'Correction amendment - returned for rework',
      112933: 'Correction amendment - sent for approval',
      11428: 'Correction accepted',
      11344: 'Correction amendment accepted',
      113334: 'Correction amendment approved',
      113429: 'Correction amendment rejected and returned for rework',
      11629: 'Commission sent for amendment',
      11286: 'Correction sent to list',
      1121: 'Correction - returned for revision',
      1131: 'Correction - returned for revision by MFIN',
      11126: 'Reporting - Sent for correction',
      1164: 'Correction - Commission approved',
      1210: 'Correction reporting - Form opening',
      1211: 'Correction reporting - Form entry',
      1212: 'Correction reporting - Sent for approval',
      1221: 'Correction reporting - Rejected from approval',
      1223: 'Correction reporting - Approved',
      1231: 'Correction reporting - Rejected from confirmation',
      1234: 'Correction reporting - Confirmed',
      1217: 'Correction reporting - Correction',
      1261: 'Correction reporting - Rationalization proposal rejected by commission',
      1256: 'Correction reporting - Rationalization proposal sent to commission',
      1215: 'Correction reporting - Sent for rationalization proposal',
      121212: 'Correction reporting - Quarter confirmation rejected',
      12112: 'Correction reporting - Quarter confirmed',
      1212131: 'Correction reporting - Quarter approved',
      12131: 'Correction reporting - Quarter rejected',
      12134: 'Correction reporting - Quarter approved',
      12126: 'Correction reporting - Sent for correction',
      12326: 'Correction reporting - Sent for correction'
    },
    importantFilter: {
      0: 'Yes',
      1: 'No'
    },
    EUFilter: {
      0: 'Yes',
      1: 'No'
    },
    activity: 'Activity',
    operation: 'Operation',
    requiredItem: 'Item ordinal number on form: ',
    required: 'It is necessary to enter a value for the listed item',
    formStatuses: {
      1: 'In entry',
      2: 'Locked',
      3: 'Evaluated',
      4: 'Approved'
    },
    revisions: 'Revisions',
    emptyProjectName: 'Welcome to the new PIMIS project',
    emptyProjectDescription: `Every project goes through several different stages. A **project stage** is one part of the complete business process during the lifetime of the project. Each stage contains different types and numbers of **forms** within which the required data relevant to that phase are entered.

System users carry out the following activities after entering data in forms:

1. **Locking**
Prevents subsequent changes to the form and enables the activity of sending for confirmation.
*Carried out by: Authorized proposer - Local user.*
2. **Sending for approval**
Users who enter data have completed the entry process and send the form for approval.
*Carried out by: Authorized proposer - Local user*
3. **Approval**
The project owner confirms that the entry is correct, or returns the form for correction.
*Carried out by: Authorized proposer - Local administrator*
4. **Confirmation**
The MFIN administrator confirms receipt of the form if they consider it to be in accordance with the regulation, or returns the form for correction.
*Carried out by: Ministry of Finance - Administration*

The listed activities are carried out when filling in any form of any stage. A stage may also have additional options and activities. All users who can access the project have permanent and detailed insight into the list of all activities carried out on it. In this way, monitoring of events on the project between any two points in time is enabled.

For all additional information use the **contextual help** button <i aria-hidden="true" class="v-icon notranslate mdi mdi-help-circle theme--light primary--text"></i> in the upper right corner of each page. Help contains detailed information about all stages and forms.`
  },
  validation: {
    warning: 'Warnings',
    error: 'Errors',
    success: 'No errors or warnings',
    nameRequired: 'Name is required',
    usernameRequired: 'Username is required',
    nameShortRequired: 'Short name is required',
    emailRequired: 'Email is required',
    claimRequired: 'At least one role or permission must be selected',
    usernameTooLong: 'Short name may contain at most 10 characters',
    nameShortTooLong: 'Username may contain at most 32 characters',
    filterUrlRequired: 'Filter URL is required',
    oldPasswordNecessary: 'Old password is required',
    newPasswordNecessary: 'Old password is required',
    repeatedPasswordNecessary: 'Old password is required',
    repeatedPasswordNotMatch: 'New and repeated password must match',
    repeatMustMatch: 'Passwords do not match',
    oldPasswordRequired: 'You must enter the old password',
    password: {
      0: 'Password character count is incorrect',
      1: 'Password must contain numbers',
      2: 'Password must contain uppercase letters',
      3: 'Password must contain symbols'
    },
    roleNameTooLong: 'User role name may contain at most 32 characters',
    roleDescriptionTooLong: 'User role description may contain at most 128 characters'
  },
  userStatus: {
    1: 'Active',
    2: 'Inactive',
    3: 'Revoked',
    4: 'Revoked access'
  },
  roleType: {
    1: 'System',
    2: 'Administration',
    3: 'User'
  },
  rowStatus: {
    active: 'Active',
    inactive: 'Inactive'
  },
  userGroupStatus: {
    1: 'Active',
    2: 'Inactive'
  },
  jsonEditor: {
    button_add: 'Add',
    button_add_row_title: 'Add {{0}}',
    button_cancel: 'Cancel',
    button_collapse: 'Collapse',
    button_copy: 'Copy',
    button_copy_row_title: 'Copy {{0}}',
    button_copy_row_title_short: 'Copy',
    button_delete_all: 'All',
    button_delete_all_title: 'Delete all',
    button_delete_last: 'Last {{0}}',
    button_delete_last_title: 'Delete last {{0}}',
    button_delete_node_warning: 'Are you sure you want to delete?',
    button_delete_row_title: 'Delete {{0}}',
    button_delete_row_title_short: 'Delete',
    button_edit_json: 'Update JSON',
    button_expand: 'Expand',
    button_move_down_title: 'Move down',
    button_move_up_title: 'Move up',
    button_object_properties: 'Object properties',
    button_properties: 'Properties',
    button_save: 'Save',
    button_upload: 'Load',
    choices_placeholder_text: 'Start typing to add a value',
    default_array_item_title: 'element',
    error_additionalItems: 'Additional elements are not allowed in this array',
    error_additional_properties: ' ',
    error_anyOf: 'Value must validate against at least one of the listed schemas',
    error_const: 'Value must be a constant',
    error_date: 'Date must be in format {{0}}',
    error_datetime_local: 'Date must be in format {{0}}',
    error_dependency: 'Must have property {{0}}',
    error_disallow: 'Value cannot be type {{0}}',
    error_disallow_union: 'Value cannot be one of the disallowed types',
    error_enum: 'Value must be one of the enum values',
    error_hostname: 'Hostname has incorrect format',
    error_invalid_epoch: 'Date must be greater than January 1, 1970',
    error_ipv4: 'Value must be a valid IPv4 address in the form of 4 numbers between 0 and 255, separated by periods',
    error_ipv6: 'Value must be a valid IPv6 address',
    error_maxItems: 'Value must have at most {{0}} elements',
    error_maxLength: 'Value must have at most {{0}} characters',
    error_maxProperties: 'Object must have at most {{0}} properties',
    error_maximum_excl: 'Value must be less than {{0}}',
    error_maximum_incl: 'Value must be at most {{0}}',
    error_minItems: 'Value must have at least {{0}} items',
    error_minLength: 'Value must have at least {{0}} characters',
    error_minProperties: 'Object must have at least {{0}} properties',
    error_minimum_excl: 'Value must be greater than {{0}}',
    error_minimum_incl: 'Value must be at least {{0}}',
    error_multipleOf: 'Value must be a multiple of {{0}}',
    error_not: 'Value must not validate against the given schema',
    error_notempty: 'Value is required',
    error_notset: 'Property must be defined',
    error_oneOf: 'Value must validate against exactly one of the given schemas. Currently validating against {{0}} schemas.',
    error_pattern: 'Value must match pattern {{0}}',
    error_property_names_const_mismatch: 'Property name {{0}} does not match the constant value',
    error_property_names_enum: 'Property name {{0}} cannot match an invalid enum',
    error_property_names_enum_mismatch: 'Property name {{0}} does not match any enum value',
    error_property_names_exceeds_maxlength: 'Property name {{0}} exceeds maximum length',
    error_property_names_false: 'Property name {{0}} gets an error when property name is false',
    error_property_names_maxlength: 'Property name {{0}} cannot match an invalid maximum length',
    error_property_names_pattern: 'Property name {{0}} cannot match an invalid pattern',
    error_property_names_pattern_mismatch: 'Property name {{0}} does not match the pattern',
    error_property_names_unsupported: 'Unsupported property name {{0}}',
    error_required: 'Object is missing required property {{0}}',
    error_time: 'Time must be in format {{0}}',
    error_type: 'Value must be of type {{0}}',
    error_type_union: 'Value must be one of the listed types',
    error_uniqueItems: 'Array must have unique elements',
    flatpickr_clear_button: 'Clear',
    flatpickr_toggle_button: 'Toggle'
  },
  apiStatusCodes: {
    0: 'Unable to establish connection, please try again after a few minutes',
    400: 'Request processing failed',
    401: 'User authorization error',
    403: 'You do not have appropriate user privileges',
    404: 'Requested page not found',
    422: 'Validation errors',
    429: 'Request limit has been reached',
    500: 'Service error, please contact technical support',
    PROJECT_NAME: 'Project name is not valid',
    ERR_PROCESS_GET_REQUEST: 'Error sending request to backend service',
    ERR_PROCESS_POST_REQUEST: 'Error sending request to backend service',
    row: 'Row',
    Success: 'Success',
    ValidationError: 'Validation error',
    Forbidden: 'You do not have rights to this action',
    NotFound: 'Path not found',
    NoticeStatus: 'Unable to update notification in given status. Notification must be in the future',
    NoticeActivity: 'Unable to update inactive notification',
    InvalidNoticeTextValidation: 'Notification text is not valid',
    InvalidNoticeStartsDateLessThenNowValidation: 'Start date cannot be in the past',
    InvalidNoticeTimeFromValidation: 'Time from is required',
    InvalidNoticeEndsDateLessThenStartsDateValidation: 'End date must be greater than start date',
    InvalidNoticeEndsDateValidation: 'End date is required',
    InvalidNoticeTimeToValidation: 'Time to is required',
    InvalidNoticeTimeToLessThenTimeFromValidation: 'Time to must be greater than time from',
    InvalidNoticeTimeToLessThenNowValidation: 'Time to must be greater than current time',
    InvalidNoticePriorityValidation: 'Priority is not valid',
    UnCreateNotice: 'Unknown error creating notification',
    UnRetrieveNotices: 'Unknown error retrieving notifications',
    UnRetrieveNotice: 'Unknown error retrieving notification',
    UnUpdateNotice: 'Unknown error updating notification',
    UnDeleteNotice: 'Unknown error deleting notification',
    UnCancelNotice: 'Unknown error cancelling notification',
    DbCreateNotice: 'Error creating notification',
    DbRetrieveNotices: 'Error retrieving notifications',
    DbRetrieveNotice: 'Error retrieving notification',
    DbUpdateNotice: 'Error updating notification',
    DbDeleteNotice: 'Error deleting notification',
    DbCancelNotice: 'Error cancelling notification',
    UnSendMailMessage: 'Unknown error sending email',
    DbCreateMailMessage: 'Error creating email',
    UncompletedPhaseForms: 'Cannot proceed to next phase while there are unprocessed forms',
    InvalidProjectFormSubmitor: 'User does not have permission to update form on project',
    InvalidProjectFormEvaluator: 'User does not have permission to evaluate form on project',
    InvalidProjectAction: 'Action is not valid',
    InvalidUserPermission: 'User does not have permission for selected action',
    DuplicateProjectOrganization: 'Duplicate organization',
    InvalidProjectFormPhase: 'Form cannot be changed in current project phase',
    InvalidProjectFormAction: 'Action is not possible in current form status',
    InvalidProjectListProjects: 'There are no valid projects meeting the list conditions',
    InvalidProjectFormValues: 'Form values are not valid',
    DuplicateProjectAppropriation: 'Duplicate appropriation',
    InvalidProjectAppropriation: 'Appropriation is not valid',
    ForbiddenProjectChange: 'Project is in a phase and status where changes are not allowed',
    ReachedProjectDocumentRevisionsLimit: 'Cannot add new document revision. Revision limit per document has been reached',
    ReachedProjectDocumentsLimit: 'Cannot add new document. Document limit per project has been reached',
    AlreadyExistsProjectDocument: 'Document with the given name already exists',
    UsedDocumentInForms: 'Cannot delete document. Document is used in forms',
    InvalidApprovedFormsCount: 'Action is not valid due to number of approved forms',
    InvalidProjectUpdateUser: 'User does not have privileges to update project because the project does not belong to their organization',
    InvalidProjectUpdatePhase: 'Project can only be updated in the first phase of projects',
    InvalidProjectUpdatePhaseStatus: 'Project can only be updated while the first project stage has not been approved',
    NotExistsProjectListDocument: 'Document not found',
    NotAllowedCreateProject: 'Project creation is not allowed for the organization the user belongs to',
    RetrieveSecuredProjectDocumentAnonymously: 'Cannot retrieve secured document through unsecured channel',
    FluentSectorEmpty: 'Project results have an impact on achieving goals or fulfilling obligations from the sector is required',
    FluentEmptyProjectImportance: 'Project of special importance is not defined',
    FluentEmptyStrategicEvaluation: 'Strategic relevance evaluation is not defined',
    FluentEmptyAppliedPlaningAndConstructionLow: 'Whether the Planning and Construction Law applies is not defined',
    FluentEmptyPlanningDocumentation: 'Planning documentation is not defined',
    FluentEmptySolvedPropertyLegalQuestions: 'Resolved property-legal issues are not defined',
    FluentEmptyGeneralProjectResult: 'PSO + GNP/PSI is not defined',
    FluentEmptyConceptualProject: 'Conceptual design is not defined',
    FluentEmptyEnvironmentalImpactStudy: 'Environmental impact study is not defined',
    FluentEmptyConceptualProjectResult: 'SO + IDP/SI is not defined',
    FluentEmptyProjectForBuildingPermit: 'Project for building permit is not defined',
    FluentEmptyProjectForExecution: 'Project for execution is not defined',
    FluentEmptyTechnicalSpecification: 'Technical specification and prerequisites for conducting public procurement',
    FluentInvalidProjectCode: 'Project working name is not valid. Only English Latin letters, numbers and characters _ and - are allowed',
    FluentEmptyProjectCode: 'Project working name is not defined',
    FluentInvalidProjectCodeLength: 'Project working name length is not valid. Must be greater than 3 and less than 20',
    FluentInvalidProjectNameLength: 'Project name length is not valid. Must be less than 512',
    FluentInvalidProjectType: 'Project type is not valid',
    FluentInvalidProjectSector: 'Sector is not valid',
    FluentInvalidFormCode: 'Form identifier is not valid',
    FluentInvalidFormAction: 'Form action is not valid',
    FluentEmptyFormValues: 'Form values are not defined',
    FluentInvalidPhaseAction: 'Phase action is not valid',
    FluentInvalidPhaseForm: 'Form identifier is not valid',
    FluentInvalidFormRevision: 'Revision is not valid',
    FluentInvalidFormExportFormat: 'Export format is not valid',
    FluentEmptyProjectFileTitle: 'Document name is not defined',
    FluentInvalidProjectFileTitleLength: 'Document name length is not valid',
    FluentEmptyProjectFileExtension: 'Document extension is not valid',
    FluentInvalidProjectFileExtension: 'Document extension is not defined',
    FluentInvalidProjectFileDescription: 'Document description length is not valid',
    FluentInvalidProjectFileComment: 'Document comment length is not valid',
    FluentInvalidProjectFileSize: 'Document size is not valid',
    FluentEmptyProjectFile: 'Document is not selected',
    FluentInvalidProjectFileRevisionId: 'Revision is not valid',
    FluentInvalidProjectFileDocumentId: 'Document identifier is not valid',
    FluentEmptyActivityName: 'Activity name is required',
    FluentEmptyActivityEstimate: 'Activity amount is required',
    FluentInvalidActivityEstimateSum: 'Sum of activity amounts does not match the estimated project value',
    FluentInvalidPlanPercentSum: 'Sum of activity percentages must be equal to 100 or 0',
    FluentInvalidPlanAmountSum: 'Sum of amounts per quarter must equal the total activity amount',
    FluentDuplicateActivityName: 'Duplicate activity exists',
    FluentEmptyPlans: 'Plan is required',
    FluentDuplicatePlanYear: 'Duplicate year exists in activities',
    FluentEmptyProjectValueRSD: 'RSD currency is required for estimated project value',
    FluentInvalidProjectValueRSDFormat: 'Amount format is not valid',
    FluentEmptyProjectValue: 'Estimated project value is required',
    FluentEmptyImplementationDates: 'Start and end of realization are required',
    FluentInvalidImplementationDates: 'End of realization cannot be before the start',
    FluentInvalidImplementationDatesLength: 'Realization duration must be longer than one year',
    FluentEmptyImplementationStartDate: 'Realization start is required',
    FluentInvalidImplementationStartDateFormat: 'Realization start is not valid',
    FluentEmptyImplementationEndDate: 'Realization end is required',
    FluentInvalidImplementationEndDateFormat: 'Realization end is not valid',
    FluentEmptyForeignAmounts: 'Estimated value in foreign currencies is not defined',
    FluentEmptyForeignAmountAmount: 'Amount in foreign currency in estimated values in foreign currencies is required',
    FluentInvalidForeignAmountAmount: 'Amount in foreign currency in estimated values in foreign currencies is not valid',
    FluentEmptyForeignAmountCurrency: 'Currency in estimated values in foreign currencies is required',
    FluentInvalidForeignAmountCurrency: 'Currency in estimated values in foreign currencies not found in register',
    FluentEmptyForeignAmountsEuroCurrency: 'EUR currency in estimated values must be defined',
    FluentInvalidForeignAmountsEuroAmount: 'Amount in EUR currency in estimated values must be greater than 5,000,000',
    FluentEmptyFinanceSources: 'Funding source is not defined',
    FluentEmptyPreparationPlan: 'Estimated funds for project preparation are not defined',
    FluentEmptyImplementationPlan: 'Estimated funds for project realization are not defined',
    FluentEmptyPreparationPlanAmount: 'Amount missing in estimated funds for project preparation',
    FluentInvalidPreparationPlanAmount: 'Invalid number format in estimated funds for project preparation',
    FluentEmptyImplementationPlanAmount: 'Amount missing in estimated funds for project realization',
    FluentInvalidImplementationPlanAmount: 'Invalid number format in estimated funds for project realization',
    FluentDifferenceImportantEstimateSources: 'Planned funds and funding sources in RSD are not equal',
    FluentEmptyFinanceSourceSource: 'Source in funding sources is required',
    FluentEmptyFinanceSourceName: 'Name in funding sources is required',
    FluentEmptyFinanceSourceLocalAmount: 'Amount in RSD in funding sources is required',
    FluentInvalidFinanceSourceLocalAmount: 'Amount in RSD in funding sources is not valid',
    FluentEmptyFinanceSourceCurrency: 'Currency in funding sources is required',
    FluentInvalidFinanceSourceCurrency: 'Currency in funding sources not found in register',
    FluentEmptyFinanceSourceAmount: 'Amount in foreign currency in funding sources is required',
    FluentFinanceSourceSumInvalid: 'Sum of amounts in RSD currency in funding sources does not match the estimated project value',
    FluentInvalidFinanceSourceAmount: 'Amount in foreign currency in funding sources is not valid',
    FluentEmptyPlanValues: 'Year in plan has no quarter defined for activity',
    FluentEmptyPlanValue: 'Quarter in plan has no amount defined',
    FluentInvalidStartDate: 'Realization start must be earlier than the date of the first quarter in activities',
    FluentInvalidEndDate: 'Realization end must be later than the date of the last quarter in activities',
    FluentInvalidCorrEndDate: 'Revised completion date as result of new plan must be later than the date of the last quarter in activities',
    FluentInvalidStartDateQuarter: 'Realization start is not aligned with the first quarter in activities',
    FluentInvalidStartDateCorrQuarter: 'Start day of new project realization plan is not aligned with the first quarter in activities',
    FluentInvalidEndDateQuarter: 'Realization end is not aligned with the last quarter in activities',
    FluentInvalidEndDateCorrQuarter: 'Revised completion date as result of new plan is not aligned with the last quarter in activities',
    FluentEmptyActivity: 'Activity is required',
    FluentActivityRealPlannedDiffEmpty: 'When there is a difference between actual and planned expenditures, reasons for deviation and measures taken must be stated.',
    FluentActivityPhysicalReasonEmpty: 'When an activity is not fully realized against the Realization Plan, reasons for deviation and measures taken must be stated.',
    FluentEmptyActivities: 'Activities are not defined',
    FluentEmptyActivityRealExpense: 'Actual expenditures are required',
    FluentInvalidActivityRealExpense: 'Actual expenditures must be greater than 0',
    FluentEmptyActivityPhysicalTargetNote: 'Reason why the milestone was not achieved must be defined',
    FluentEmptyActivityFinancialTargetNote: 'Reason why the target value was not achieved must be defined',
    FluentEmptyProjectChangesActivity: 'Change of estimated total costs and project completion date must be defined',
    FluentEmptyProjectChangesActivityData: 'Change of estimated total costs or project completion date must be defined',
    FluentDuplicateProjectChangesActivityName: 'Duplicate activity exists in change of estimated total costs and project completion date',
    FluentEmptyProjectChangesActivityName: 'Activity in change of estimated total costs and project completion date is required',
    FluentEmptyProjectChangesEstimateReason: 'Reasons for cost changes are required',
    FluentEmptyProjectChangesDateReason: 'Reasons for estimated date changes are required',
    FluentEmptyProjectChanges: 'Change of estimated total project costs is not defined',
    FluentEmptyProjectName: 'Project name is required',
    FluentProjectNameInvalid: 'Project name is missing or has fewer than 5 letters',
    FluentEmptyProposerOrganization: 'Capital project idea proposer is not defined',
    FluentEmptyAuthorizedOrganization: 'Authorized capital project proposer is not defined',
    FluentInvalidProposerOrganizationFormat: 'Capital project idea proposer format is not valid. Did you select the proposer from the suggested list?',
    FluentInvalidEstimateTotal: 'Capital project value must be greater than 20,000,000 euros',
    FluentExpensesSourcesNeedsToBeLessOrEqualToEstimateTotalInDinarsInvalid: 'Potential funding sources total cannot be greater than Estimated costs - Total estimated costs in RSD',
    FluentExpensesSourcesNeedsToBeGreaterThanZeroInvalid: 'Potential funding sources total must be greater than 0',
    FluentExpensesSourceNameEmpty: 'Name of source in potential funding sources must be filled in.',
    FluentInvalidConstructionPeriodInvalid: 'Preliminary estimate of capital project duration must be longer than 11 months',
    FluentFeasibilityPredictedSourceInvalid: 'All sources listed in point 4.2 must also be listed in point 4.4',
    FluentFeasibilityPreparationAmountInvalid: 'Budget provided in point 4.2 must not be greater than the amount provided for project preparation in point 4.1.',
    FluentInvalidProposerOrganization: 'Capital project idea proposer not found in register',
    FluentInvalidLocationFormat: 'Location format is not valid. Did you select the location from the suggested list?',
    FluentInvalidLocation: 'Location not found in register',
    FluentDuplicatedLocation: 'Same locations entered',
    FluentEmptyLocation: 'Locations are not defined',
    FluentExpenseSourceEmpty: 'Potential funding sources must add Amount in RSD or Amount in foreign currency or Currency type',
    FluentExpenseSourceZero: 'Potential funding sources cannot be 0',
    FluentExpenseCurrencyMissing: 'Potential funding sources must have currency entered',
    FluentProjectDescriptionEmpty: 'Brief description (summary) of preliminary project idea project description is not defined',
    FluentPlanCompatibilityEmpty: 'Link to planning documents is not defined',
    FluentEmptyProjectImplementationDetails: 'Whether the project started realization before 01.01.2023 must be defined',
    FluentEmptyProjectImplementationDetailsStart: 'Actual project start date must be defined',
    FluentInvalidProjectImplementationDetailsStart: 'Actual project start date is not valid',
    FluentEmptyProjectImplementationDetailsAmount: 'Total project value in RSD must be defined',
    FluentInvalidProjectImplementationDetailsAmount: 'Total project value in RSD is not valid',
    FluentEmptyResponsiblePeople: 'Responsible or authorized contact persons are not defined',
    FluentProjectPreparationDepartmentEmpty: 'Department responsible for project preparation managers are not defined',
    FluentProjectMonitoringAndImplementationDepartmentManagersEmpty: 'Department for project monitoring and implementation managers are not defined',
    FluentEmptyResponsiblePersonName: 'Name of responsible or authorized contact person is not defined',
    FluentEmptyResponsiblePersonFunction: 'Function of responsible or authorized contact person is not defined',
    FluentReachedResponsiblePersonEmailCountLimit: 'Number of emails of responsible or authorized contact person is greater than 3',
    FluentInvalidResponsiblePersonEmail: 'Email of responsible or authorized contact person is not valid',
    FluentReachedResponsiblePersonPhoneCountLimit: 'Number of phones of responsible or authorized contact person is greater than 3',
    FluentInvalidResponsiblePersonPhone: 'Phone of responsible or authorized contact person is not valid',
    FluentEmptyStrategySectorName: 'Policy/strategy sector name is not defined',
    FluentEmptyStrategySectorManager: 'Policy/strategy sector manager is not defined',
    FluentEmptyCooperationSectorName: 'IPA projects and international cooperation sector name is not defined',
    FluentEmptyCooperationSectorManager: 'IPA projects and international cooperation sector manager is not defined',
    FluentEmptyPreparationDepartmentName: 'Project preparation department name is not defined',
    FluentEmptyPreparationDepartmentManager: 'Project preparation department manager is not defined',
    FluentEmptyPreparationDepartmentManagers: 'Project preparation department managers are not defined',
    FluentEmptyPreparationDepartmentManagerName: 'Project preparation department manager name is not defined',
    FluentEmptyPreparationDepartmentManagerFunction: 'Project preparation department manager function is not defined',
    FluentReachedPreparationDepartmentManagerEmailCountLimit: 'Number of emails of project preparation department manager is greater than 3',
    FluentInvalidPreparationDepartmentManagerEmail: 'Email of project preparation department manager is not valid',
    FluentReachedPreparationDepartmentManagerPhoneCountLimit: 'Number of phones of project preparation department manager is greater than 3',
    FluentInvalidPreparationDepartmentManagerPhone: 'Phone of project preparation department manager is not valid',
    FluentEmptyMonitoringDepartmentName: 'Project monitoring and implementation department name is not defined',
    FluentEmptyMonitoringDepartmentManager: 'Project monitoring and implementation department manager is not defined',
    FluentEmptyMonitoringDepartmentManagerName: 'Project monitoring and implementation department manager name is not defined',
    FluentEmptyMonitoringDepartmentManagerFunction: 'Project monitoring and implementation department manager function is not defined',
    FluentReachedMonitoringDepartmentManagerEmailCountLimit: 'Number of emails of project monitoring and implementation department manager is greater than 3',
    FluentInvalidMonitoringDepartmentManagerEmail: 'Email of project monitoring and implementation department manager is not valid',
    FluentReachedMonitoringDepartmentManagerPhoneCountLimit: 'Number of phones of project monitoring and implementation department manager is greater than 3',
    FluentInvalidMonitoringDepartmentManagerPhone: 'Phone of project monitoring and implementation department manager is not valid',
    FluentEmptyMonitoringDepartmentManagers: 'Project monitoring and implementation department managers are not defined',
    FluentEmptySuggestionCorrection: 'Project correction is not defined',
    FluentEmptySuggestionPostponement: 'Project postponement is not defined',
    FluentEmptySuggestionClosure: 'Project closure is not defined',
    FluentEmptyDelayNote: 'Reason for delay is required',
    FluentEmptyExpenses: 'Total project realization costs are required',
    FluentEmptyEstimatedExpense: 'Planned costs in total project realization costs are required',
    FluentInvalidEstimatedExpense: 'Planned costs in total project realization costs are not valid',
    FluentEmptyActualExpense: 'Realized costs in total project realization costs are required',
    FluentInvalidActualExpense: 'Realized costs in total project realization costs are not valid',
    FluentEmptyExpensePercent: 'Plan realization percentage in total project realization costs is required',
    FluentEInvalidExpensePercent: 'Plan realization percentage in total project realization costs is not valid',
    FluentEmptyExpenseSources: 'Costs by funding sources are required',
    FluentEmptyExpenseSourceSource: 'Source in costs by funding sources is required',
    FluentEmptyExpenseSourceName: 'Name in costs by funding sources is required',
    FluentEmptyExpenseDeviationNote: 'Reasons for deviation are not defined',
    FluentEmptyOtherNote: 'Explanation is not defined',
    FluentPartnershipQuestionEmpty: 'Whether the capital project is realized through public-private partnership or concession defined by the law governing public-private partnership and concession comment is not defined',
    FluentAcceptanceIdeaEmpty: 'Development planning documents comment is not defined',
    FluentPolicyDocumentsEmpty: 'Public policy documents comment is not defined',
    FluentOtherDocumentsEmpty: 'Other planning documents comment is not defined',
    FluentEuPoliticEmpty: 'EU policy comment is not defined',
    FluentInstitutionalFrameworkOtherEmpty: 'Other persons, key ministries and organizations are not defined',
    FluentAffectedLocationEmpty: 'Project location is not defined',
    FluentEstimatePreparationEmpty: 'Estimated project preparation costs in RSD are not defined',
    FluentEstimateRealizationEmpty: 'Estimated capital project realization costs in RSD',
    FluentExplanationSectorEmpty: 'Explanation of relationship between lead sector and other sectors where project realization will have impact is not defined',
    FluentProjectNameEmpty: 'Project name is required and must have a minimum of 5 letters',
    FluentEmptyExpenseSourceAmounts: 'Amounts in costs by funding sources are required',
    FluentEmptyDelayProjectApprovedDate: 'Project approval date / Approved list of prepared capital projects is not defined',
    FluentEmptyDelayFinalProjectEndDate: 'Current project completion date is not defined',
    FluentInvalidDelayFinalProjectEndDate: 'Current project completion date is not valid',
    FluentEmptyUnpredictedSelection: 'Selection of unforeseen activities is not defined',
    FluentEmptyUnpredictedActivities: 'Unforeseen activities are not defined',
    FluentEmptyUnpredictedActivityName: 'Unforeseen activity name is not defined',
    FluentDuplicateUnpredictedActivityName: 'Duplicate unforeseen activity exists',
    FluentDuplicateUnpredictedRealActivityName: 'Unforeseen activity with the same name as a planned activity exists',
    FluentEmptyUnpredictedActivityExpense: 'Unforeseen activity expense is not defined',
    FluentEmptyUnpredictedComment: 'Explanation for the existence of unforeseen activities is required',
    FluentEmptyParticipantOrganization: 'Organization name in additional participants is not defined',
    FluentEmptyParticipantName: 'Full name of additional participant is not defined',
    FluentInvalidParticipantEmail: 'Email address of additional participant is not valid',
    FluentInvalidParticipantPhone: 'Phone of additional participant is not valid',
    FluentEstimateCommentInvalid: 'Explanation of estimated costs calculation must be filled in.',
    FluentEmptyProjectFormAppropriations: 'Appropriations are not defined',
    FluentEmptyProjectDocumentType: 'Document must have a type',
    FluentEmptyProjectDocumentUnknownType: 'Unknown document type',
    FluentExpectedGoalsEmpty: 'Realization of this project contributes to fulfilling strategic goals that are defined is not defined',
    FluentAssessment1Empty: 'Realization of this project contributes to fulfilling strategic goals that are defined - Strategic relevance evaluation is not defined',
    FluentImplementationGoalsEmpty: 'Project results have an impact on the implementation of sectoral strategies/programs is not defined',
    FluentValidateAssessment2Empty: 'Project results have an impact on the implementation of sectoral strategies/programs - Strategic relevance evaluation is not defined',
    FluentImplementationInternationalEmpty: 'Realization of this project contributes to fulfilling obligations from international treaties and agreements of the Republic of Serbia data is not defined',
    FluentAssessment3Empty: 'Realization of this project contributes to fulfilling obligations from international treaties and agreements of the Republic of Serbia is required - Strategic relevance evaluation is not defined',
    FluentImplementationEUEmpty: 'Realization of this project contributes to fulfilling obligations from the EU integration process is not defined',
    FluentAssessment4Empty: 'Realization of this project contributes to fulfilling obligations from the EU integration process is required - Strategic relevance evaluation is not defined',
    FluentPopulationEffectEmpty: 'Project results have a positive effect on the population is not defined 1',
    FluentAssessment5Empty: 'Project results have a positive effect on the population - Strategic relevance evaluation is not defined',
    FluentImplementationEffectEmpty: 'Project results have a positive effect on the population is not defined 2',
    FluentCrossBorderEffectsEmpty: 'Strategic relevance evaluation is not defined',
    FluentUnderdevelopedRegionsEmpty: 'Strategic relevance evaluation is not defined',
    FluentDevastatedAreasEmpty: 'Strategic relevance evaluation is not defined',
    FluentImplementationEnablesEmpty: 'Realization of this project enables is not defined',
    FluentOtherAssessment7Empty: 'Strategic relevance evaluation is not defined 7',
    FluentNotRealizedEmpty: 'What would happen if the project proposal were not realized is not defined',
    FluentAssessment8Empty: 'Strategic relevance evaluation is not defined 8',
    FluentProjectObjectivesEmpty: 'What is/are the objective(s) of the proposed project? is not defined',
    FluentAssessment9Empty: 'Strategic relevance evaluation is not defined 9',
    FluentPlannedActivitiesEmpty: 'What are the planned activities, results and outcomes of the proposed project is not defined',
    FluentAssessment10Empty: 'What are the planned activities, results and outcomes of the proposed project is not defined - Quality evaluation is not defined',
    FluentPlannedUsersEmpty: 'Who are the planned project users and how many are there is not defined',
    FluentAssessment11Empty: 'Who are the planned project users and how many are there is not defined - Quality evaluation is not defined',
    FluentPositiveNegativeEmpty: 'List all positive and negative project impacts from the perspective of sustainable development and climate change is not defined',
    FluentAssessment12Empty: 'List all positive and negative project impacts from the perspective of sustainable development and climate change is required - Quality evaluation is not defined',
    FluentGoalsImportantEmpty: 'Greatest positive impact is not defined',
    FluentGoalsOthersEmpty: 'Also impacts some other goals is not defined',
    FluentNotesEmpty: 'Notes are not defined',
    FluentNoteFinancialAspectsEmpty: 'Estimated total capital project costs - preparation amount is not defined',
    FluentCapitalRealizationEmpty: 'Estimated funds for project realization must be defined and greater than 0',
    FluentFeasibilityStudyEmpty: 'What budget would be needed for the development of a (preliminary) feasibility/justification study is not defined',
    FluentFeasibilityStudyBiggerThenTotalExpensesValidation: 'What budget would be needed for the development of a (preliminary) feasibility/justification study is a greater amount than - Estimated funds for project preparation in RSD',
    FluentCapitalRequirementsRiskEmpty: 'Estimated costs for each year is not defined',
    FluentCapitalRequirementsRiskYearEmpty: 'Estimated costs for each year - Fiscal year is not defined',
    FluentCapitalRequirementsRiskAmountEmpty: 'Estimated costs for each year - Required amount is not defined',
    FluentValidateCapitalRequirementsEqualToEstimateTotalInvalid: 'Total sum of estimated costs for each year should be equal to the amount of estimated total costs for project preparation and realization.',
    FluentValidateCapitalRequirementsCapitalsSourcesEqualsContextChoice2Invalid: 'Total sum - Estimated costs for each year of project realization in relation to planned project realization timeframe - is not equal to - Estimated project realization costs',
    FluentValidateFundingCapitalsInvalid: 'Estimated costs for each year of funding must equal the sum of planned sources (point 5)',
    FluentValidateSummaryContextChoiceContextChoice2LessThenContextChoice3Invalid: 'Estimated total project costs (preparation + realization/construction) - cannot be less than the sum of - Expended funds for project preparation and Estimated total project costs (preparation + realization/construction)',
    FluentValidatePredictedSourceEqualToEstimateTotalInvalid: 'Planned funding sources does not equal - Data on financial aspect of project proposal - Total costs',
    FluentPredictedSourceInRangeOfConstructionPeriodInvalid: '1. Estimated project duration, in months must be greater than or equal to - 4.3 Estimated costs for each year - Fiscal year, sum of months of all years',
    FluentConstructionPeriodInRangeOfEndPrepartionStartCompletionWorkEndInvalid: 'Preparation completion/assessment - planned preparation date to End of works/realization - Planned completion date is a longer period than Estimated project duration',
    FluentRiskEmpty: 'Risk is not defined',
    FluentRiskNameEmpty: 'Risk - Describe the risk is not defined',
    FluentRiskDegreeEmpty: 'Risk - Estimated risk degree is not defined',
    FluentRiskManagerEmpty: 'Risk - How the risk will be managed is not defined',
    FluentOperatingTotalEmpty: 'Total estimated annual operating costs of the project are not defined',
    FluentOperatingOldEmpty: 'How much of the costs will be covered from the existing budget is not defined',
    FluentOperatingNewEmpty: '',
    FluentNewCostsSourcesEmpty: '',
    FluentPreviousTextEmpty: 'Total expropriation costs are estimated is not defined',
    FluentIncomeChoiceEmpty: '',
    FluentIncomeTextRiskEmpty: '',
    FluentIncomeTextWhoManageEmpty: '',
    FluentValidateNewCostsSourcesEqualsOperatingNewInvalid: 'Annual operating costs - New operating costs must be the total amount of - Sources of additional operating and maintenance costs',
    FluentNewCostsEmpty: 'Sources of additional operating and maintenance costs are not defined',
    FluentNewCostLocalAmountEmpty: 'Sources of additional operating and maintenance costs - Amount in RSD',
    FluentNewCostAmountEmpty: 'Sources of additional operating and maintenance costs - Amount in foreign currency',
    FluentNewCostCurrencyEmpty: 'Sources of additional operating and maintenance costs - Currency',
    FluentIncomeEmpty: 'Income is not defined',
    FluentIncomeYearEmpty: 'Income - Operating year is not defined',
    FluentIncomeAmountEmpty: 'Income - Estimated expenditures are not defined',
    FluentPredictedSourceSourcesEmpty: 'Planned funding sources',
    FluentPredictedSourceSourcesLocalAmountEmpty: 'Planned funding sources - Amount in RSD',
    FluentPredictedSourceSourcesCurrencyEmpty: 'Planned funding sources - Currency',
    FluentPredictedSourceSourcesPercentageEmpty: 'Planned funding sources - Amount (%)',
    FluentPredictedSourceSourcesProvidedEmpty: 'Planned funding sources - Secured',
    FluentEndPreparationStartEmpty: 'Preparation/assessment completion - Planned start date is not defined',
    FluentEndPreparationEndEmpty: 'Preparation/assessment completion - Planned completion date is not defined',
    FluentPublicInvitationStartEmpty: 'Public procurement call - Planned start date is not defined',
    FluentPublicInvitationEndEmpty: 'Public procurement call - Planned completion date is not defined',
    FluentAwardContractStartEmpty: 'Contract award - Planned start date is not defined',
    FluentAwardContractEndEmpty: 'Contract award - Planned completion date is not defined',
    FluentWapper4StartEmpty: 'Start of works/realization - Planned start date is not defined',
    FluentWapper4EndEmpty: 'Start of works/realization - Planned completion date is not defined',
    FluentCompletionWorksStartEmpty: 'Completion of works/realization - Planned start date is not defined',
    FluentCompletionWorksEndEmpty: 'Completion of works/realization - Planned completion date is not defined',
    FluentProjectOperationalStartEmpty: 'Project becomes operational - Planned start date is not defined',
    FluentProjectOperationalEndEmpty: 'Project becomes operational - Planned completion date is not defined',
    FluentPublicInvitationEndSmaller: 'Planned completion date of public procurement call is less than the planned preparation completion date.',
    FluentAwardContractEndSmaller: 'Planned completion date of contract award is less than the planned completion date of the public procurement call.',
    FluentWapper4EndSmaller: 'Planned completion date of start of works is less than the planned completion date of contract award.',
    FluentCompletionWorksEndSmaller: 'Planned completion date of works is less than the planned completion date of start of works.',
    FluentProjectOperationalEndSmaller: 'Planned operational completion date is less than the planned completion date of works.',
    FluentPreviousExperienceEmpty: 'Whether the project proposer has experience in implementing similar capital projects is not defined',
    FluentPreviousExperienceYesEmpty: 'If the proposer has previous experience in implementing similar projects (for example "repeated" projects such as clinics or schools) this implies a high level of confidence that the proposed project can be implemented adequately, if funding is approved. The proposer should list similar projects successfully implemented in the past five years is not defined',
    FluentPreviousExperienceNoEmpty: 'If there was no previous experience or the proposed project contains a significant level of innovation, this will be considered a potential risk in terms of successful implementation. In that case, the proposer should describe measures (for example, engaging expert staff or external consultants) that will mitigate or eliminate potential risks in project realization is not defined',
    FluentAgencyCommunalEmpty: 'List agencies, public utility companies and regulatory institutions (holders of public authority) that perform activities of relevance to the capital project realization is not defined',
    FluentInterestHoldersEmpty: 'List project stakeholders with information on whether they have been consulted regarding this capital project is not defined',
    FluenteneralRiskEmpty: 'List potential general risks is required',
    FluentGeneralRiskWhoManageEmpty: 'List potential assessments of who will manage the risk is required',
    FluentEnvironmentQuestionsEmpty: 'Item 5.6. - List significant environmental impact issues is not defined',
    FluentLocalGovermentEmpty: 'Competent ministry/local self-government unit or autonomous province is not defined',
    FluentImportantSectorEmpty: 'List the lead sector is required',
    FluentOtherSectorsEmpty: 'Project results have an impact on achieving goals or fulfilling obligations from - Other sectors is required',
    FluentPoliticsStrategySectorNameEmpty: 'Item 1. - Policy/strategy sector - sector/department name is not defined',
    FluentInternationalCooperationSectorNameEmpty: 'Policy/strategy sector - Manager is not defined',
    FluentPoliticsStrategySectorManagerEmpty: 'Sector responsible for IPA projects and international cooperation - Sector/department name is not defined',
    FluentProjectPreparationDepartmentNameEmpty: 'Project monitoring and implementation department - Sector/department name is not defined',
    FluentProjectPreparationDepartmentManagerEmpty: 'Project monitoring and implementation department - Manager is not defined',
    FluentInternationalCooperationSectorManagerEmpty: 'Sector responsible for IPA projects and international cooperation - Manager is not defined',
    FluentProjectMonitoringAndImplementationDepartmentNameEmpty: 'Department responsible for project preparation - Department is not defined',
    FluentProjectMonitoringAndImplementationDepartmentManagerEmpty: 'Project monitoring and implementation department - Manager is not defined',
    FluentProcurementTextEmpty: 'Type of services is not defined',
    FluentProcurementText2Empty: 'Equipment procurement is not defined',
    FluentProcurementText3Empty: 'Infrastructure projects/real estate procurement is not defined',
    FluentConstructionChoiceEmpty: 'Whether there is a need for construction work related to equipment procurement and installation is not defined',
    FluentScopeTextEmpty: 'Coherent with project objectives - comment missing',
    FluentScopeText2Empty: 'Consistent with development plan objectives - comment missing',
    FluentScopeText3Empty: 'Aligned with regulatory and legal framework - comment missing',
    FluentScopeText4Empty: 'Has a framework implementation plan - comment missing',
    FluentScopeText5Empty: 'Has identified clients/buyers or project users - comment missing',
    FluentScopeText6Empty: 'Has prepared project-tender documentation - comment missing',
    FluentScopeText7Empty: 'Has identified critical project points - comment missing',
    FluentScopeText8Empty: 'Has identified potential risks and problems - comment missing',
    FluentScopeText9Empty: 'Has defined mechanisms for resolving/mitigating potential risks/problems - comment missing',
    FluentScopeText10Empty: 'Has defined human/institutional or material/technical resources needed for project realization - comment missing',
    FluentScopeText11Empty: 'Has a Preliminary feasibility/justification study - comment missing',
    FluentScopeText12Empty: 'Has clearly defined roles and responsibilities - comment missing',
    FluentActivityInfrastructureCompletionDateMonthEmpty: 'Whether an architectural competition was conducted in accordance with the law governing planning and construction - Activity completion date - Month is not defined',
    FluentActivityInfrastructureCompletionDateYearEmpty: 'Whether an architectural competition was conducted in accordance with the law governing planning and construction - Activity completion date - Year is not defined',
    FluentActivityInfrastructureDocumentDateMonthEmpty: 'Whether an architectural competition was conducted in accordance with the law governing planning and construction - Document preparation date - Month is not defined',
    FluentActivityInfrastructureDocumentDateYearEmpty: 'Whether an architectural competition was conducted in accordance with the law governing planning and construction - Document preparation date - Year is not defined',
    FluentActivityInfrastructureCompletionDateMonth2Empty: 'Land acquisition (Formally available land) - Activity completion date - Month is not defined',
    FluentActivityInfrastructureCompletionDateYear2Empty: 'Land acquisition (Formally available land) - Activity completion date - Year is not defined',
    FluentActivityInfrastructureDocumentDateMonth2Empty: 'Land acquisition (Formally available land) - Document preparation date - Month is not defined',
    FluentActivityInfrastructureDocumentDateYear2Empty: 'Land acquisition (Formally available land) - Document preparation date - Year is not defined',
    FluentActivityInfrastructureCompletionDateMonth4Empty: 'Preliminary feasibility study (if required) - Activity completion date - Month is not defined',
    FluentActivityInfrastructureCompletionDateYear4Empty: 'Preliminary feasibility study (if required) - Activity completion date - Year is not defined',
    FluentActivityInfrastructureDocumentDateMonth4Empty: 'Preliminary feasibility study (if required) - Document preparation date - Month is not defined',
    FluentActivityInfrastructureDocumentDateYear4Empty: 'Preliminary feasibility study (if required) - Document preparation date - Year is not defined',
    FluentActivityInfrastructureCompletionDateMonth5Empty: 'Feasibility/justification study - Activity completion date - Month is not defined',
    FluentActivityInfrastructureCompletionDateYear5Empty: 'Feasibility/justification study - Activity completion date - Year is not defined',
    FluentActivityInfrastructureDocumentDateMonth5Empty: 'Feasibility/justification study - Document preparation date - Month is not defined',
    FluentActivityInfrastructureDocumentDateYear5Empty: 'Feasibility/justification study - Document preparation date - Year is not defined',
    FluentActivityInfrastructureCompletionDateMonth6Empty: 'Institute for Protection of Cultural Monuments approval (if required) - Activity completion date - Month is not defined',
    FluentActivityInfrastructureCompletionDateYear6Empty: 'Institute for Protection of Cultural Monuments approval (if required) - Activity completion date - Year is not defined',
    FluentActivityInfrastructureDocumentDateMonth6Empty: 'Institute for Protection of Cultural Monuments approval (if required) - Document preparation date - Month is not defined',
    FluentActivityInfrastructureDocumentDateYear6Empty: 'Institute for Protection of Cultural Monuments approval (if required) - Document preparation date - Year is not defined',
    FluentActivityInfrastructureCompletionDateMonth7Empty: 'Environmental impact assessment (if required) - Activity completion date - Month is not defined (point 3.3)',
    FluentActivityInfrastructureCompletionDateYear7Empty: 'Environmental impact assessment (if required) - Activity completion date - Year is not defined (point 3.3)',
    FluentActivityInfrastructureDocumentDateMonth7Empty: 'Environmental impact assessment (if required) - Document preparation date - Month is not defined (point 3.3)',
    FluentActivityInfrastructureDocumentDateYear7Empty: 'Environmental impact assessment (if required) - Document preparation date - Year is not defined (point 3.3)',
    FluentActivityInfrastructureCompletionDateMonth8Empty: 'General project - Activity completion date - Month is not defined',
    FluentActivityInfrastructureCompletionDateYear8Empty: 'General project - Activity completion date - Year is not defined',
    FluentActivityInfrastructureDocumentDateMonth8Empty: 'General project - Document preparation date - Month is not defined',
    FluentActivityInfrastructureDocumentDateYear8Empty: 'General project - Document preparation date - Year is not defined',
    FluentActivityInfrastructureCompletionDateMonth9Empty: 'Conceptual design - Activity completion date - Month is not defined',
    FluentActivityInfrastructureCompletionDateYear9Empty: 'Conceptual design - Activity completion date - Year is not defined',
    FluentActivityInfrastructureDocumentDateMonth9Empty: 'Conceptual design - Document preparation date - Month is not defined',
    FluentActivityInfrastructureDocumentDateYear9Empty: 'Conceptual design - Document preparation date - Year is not defined',
    FluentActivityInfrastructureCompletionDateMonth10Empty: 'Preliminary project - Activity completion date - Month is not defined',
    FluentActivityInfrastructureCompletionDateYear10Empty: 'Preliminary project - Activity completion date - Year is not defined',
    FluentActivityInfrastructureDocumentDateMonth10Empty: 'Preliminary project - Document preparation date - Month is not defined',
    FluentActivityInfrastructureDocumentDateYear10Empty: 'Preliminary project - Document preparation date - Year is not defined',
    FluentActivityInfrastructureCompletionDateMonth11Empty: 'Project for building permit - Activity completion date - Month is not defined',
    FluentActivityInfrastructureCompletionDateYear11Empty: 'Project for building permit - Activity completion date - Year is not defined',
    FluentActivityInfrastructureDocumentDateMonth11Empty: 'Project for building permit - Document preparation date - Month is not defined',
    FluentActivityInfrastructureDocumentDateYear11Empty: 'Project for building permit - Document preparation date - Year is not defined',
    FluentActivityInfrastructureCompletionDateMonth13Empty: 'Building permit - Activity completion date - Month is not defined',
    FluentActivityInfrastructureCompletionDateYear13Empty: 'Building permit - Activity completion date - Year is not defined',
    FluentActivityInfrastructureDocumentDateMonth13Empty: 'Building permit - Document preparation date - Month is not defined',
    FluentActivityInfrastructureDocumentDateYear13Empty: 'Building permit - Document preparation date - Year is not defined',
    FluentActivityInfrastructureCompletionDateMonth12Empty: 'Project for execution - Activity completion date - Month is not defined',
    FluentActivityInfrastructureCompletionDateYear12Empty: 'Project for execution - Activity completion date - Year is not defined',
    FluentActivityInfrastructureDocumentDateMonth12Empty: 'Project for execution - Document preparation date - Month is not defined',
    FluentActivityInfrastructureDocumentDateYear12Empty: 'Project for execution - Document preparation date - Year is not defined',
    FluentActivityInfrastructureCompletionDateMonth14Empty: 'Tender documentation - Activity completion date - Month is not defined',
    FluentActivityInfrastructureCompletionDateYear14Empty: 'Tender documentation - Activity completion date - Year is not defined',
    FluentActivityInfrastructureDocumentDateMonth14Empty: 'Tender documentation - Document preparation date - Month is not defined',
    FluentActivityInfrastructureDocumentDateYear14Empty: 'Tender documentation - Document preparation date - Year is not defined',
    FluentActivityInfrastructureCompletionDateMonth15Empty: 'Procurement is part of a broader program - Activity completion date - Month is not defined',
    FluentActivityInfrastructureCompletionDateYear15Empty: 'Procurement is part of a broader program - Activity completion date - Year is not defined',
    FluentActivityInfrastructureDocumentDateMonth15Empty: 'Procurement is part of a broader program - Document preparation date - Month is not defined',
    FluentActivityInfrastructureDocumentDateYear15Empty: 'Procurement is part of a broader program - Document preparation date - Year is not defined',
    FluentActivityInfrastructureChoiceEmpty: 'Whether an architectural competition was conducted in accordance with the law governing planning and construction is not defined',
    FluentActivityInfrastructureChoice2Empty: 'Land acquisition (Formally available land) is not defined',
    FluentActivityInfrastructureChoice3Empty: 'Preliminary feasibility study (if required) is not defined',
    FluentActivityInfrastructureChoice4Empty: 'Feasibility/justification study is not defined',
    FluentActivityInfrastructureChoice5Empty: 'Institute for Protection of Cultural Monuments approval (if required) is not defined',
    FluentActivityInfrastructureChoice6Empty: 'Environmental impact assessment (if required) is not defined',
    FluentActivityInfrastructureChoice7Empty: 'General project is not defined',
    FluentActivityInfrastructureChoice8Empty: 'Conceptual design is not defined',
    FluentActivityInfrastructureChoice9Empty: 'Preliminary project is not defined',
    FluentActivityInfrastructureChoice10Empty: 'Project for building permit is not defined',
    FluentActivityInfrastructureChoice11Empty: 'Building permit is not defined',
    FluentActivityInfrastructureChoice12Empty: 'Project for execution is not defined',
    FluentActivityInfrastructureChoice13Empty: 'Tender documentation is not defined',
    FluentActivityDateEmpty: 'All prerequisites for realization secured on the side of the capital project idea Proposer - Activity completion date is not defined',
    FluentActivityTextEmpty: 'State prerequisites for "Yes" or "No" - Comment is not defined',
    FluentActivityDate2Empty: 'Service performed by idea Proposer alone - Activity completion date is not defined',
    FluentActivityText2Empty: 'Service performed by idea Proposer alone - Comment is not defined',
    FluentActivityDate3Empty: 'Service performed by idea Proposer with other government bodies - Activity completion date is not defined',
    FluentActivityText3Empty: 'Service performed by idea Proposer with other government bodies - Defined or identified government bodies is not defined',
    FluentActivityDate4Empty: 'State another way for service realization - Activity completion date is not defined',
    FluentActivityText4Empty: 'State another way for service realization - Comment is not defined',
    FluentActivityCommentEmpty: 'Please provide clarifications or additional information on the above if you consider it necessary is not defined',
    FluentActivityEquipmentChoiceEmpty: 'Defined specific characteristics of the subject equipment procurement is not defined',
    FluentActivityEquipmentDateEmpty: 'Defined specific characteristics of the subject equipment procurement - Activity completion date is not defined',
    FluentActivityEquipmentTextEmpty: 'Defined specific characteristics of the subject equipment procurement - Comment is not defined',
    FluentActivityEquipmentChoice2Empty: 'Defined quantities of the subject equipment procurement is not defined is not defined',
    FluentActivityEquipmentDate2Empty: 'Defined quantities of the subject equipment procurement - Activity completion date is not defined',
    FluentActivityEquipmentText2Empty: 'Defined quantities of the subject equipment procurement - Comment is not defined',
    FluentActivityEquipmentChoice3Empty: 'Existence of tender documentation is not defined is not defined',
    FluentActivityEquipmentDate3Empty: 'Existence of tender documentation - Activity completion date is not defined',
    FluentActivityEquipmentText3Empty: 'Existence of tender documentation - Comment is not defined',
    FluentActivityEquipmentChoice4Empty: 'Use of procured equipment requires construction work at the capital project idea proposer is not defined',
    FluentActivityEquipmentDate4Empty: 'Use of procured equipment requires construction work at the capital project idea proposer - Activity completion date is not defined',
    FluentActivityEquipmentText4Empty: 'Use of procured equipment requires construction work at the capital project idea proposer - Comment is not defined',
    FluentActivityEquipmentChoice5Empty: 'Funds for construction work secured (if required) is not defined is not defined',
    FluentActivityEquipmentDate5Empty: 'Funds for construction work secured (if required) - Activity completion date is not defined',
    FluentActivityEquipmentText5Empty: 'Funds for construction work secured (if required) - Comment is not defined',
    FluentActivityEquipmentChoice6Empty: 'Construction prerequisites for successful installation of the subject procurement secured (if applicable) is not defined',
    FluentActivityEquipmentDate6Empty: 'Construction prerequisites for successful installation of the subject procurement secured (if applicable) - Activity completion date is not defined',
    FluentActivityEquipmentText6Empty: 'Construction prerequisites for successful installation of the subject procurement secured (if applicable) - Comment is not defined',
    FluentActivityEquipmentChoice7Empty: 'Use of procured equipment requires technical/technological upgrades at the capital project idea proposer is not defined',
    FluentActivityEquipmentDate7Empty: 'Use of procured equipment requires technical/technological upgrades at the capital project idea proposer - Activity completion date is not defined',
    FluentActivityEquipmentText7Empty: 'Use of procured equipment requires technical/technological upgrades at the capital project idea proposer - Comment is not defined',
    FluentActivityEquipmentChoice8Empty: 'Funds secured for creating technical/technological prerequisites for equipment use is not defined',
    FluentActivityEquipmentDate8Empty: 'Funds secured for creating technical/technological prerequisites for equipment use - Activity completion date is not defined',
    FluentActivityEquipmentText8Empty: 'Funds secured for creating technical/technological prerequisites for equipment use - Comment is not defined',
    FluentActivityEquipmentChoice9Empty: 'Procurement is part of a broader program is not defined',
    FluentActivityEquipmentDate9Empty: 'Procurement is part of a broader program - Activity completion date is not defined',
    FluentActivityEquipmentText9Empty: 'Procurement is part of a broader program - Comment is not defined',
    FluentActivityCommentEquipmentEmpty: 'State clarifications/additional information about the above technical documentation, especially for reconstruction projects of existing facilities is not defined',
    FluentIdentificationOptionEmpty: 'Option identification - Whether different investment options have been analyzed is not defined',
    FluentIdentificationOptionScenario1Empty: '"Do nothing" scenario - what opportunities will be missed in this scenario is not defined',
    FluentIdentificationOptionScenario2Empty: '"Do minimum" scenario - what minimum effort is needed to achieve objectives is not defined',
    FluentIdentificationOptionScenario3Empty: '"Do something" scenario - what different options were analyzed and why they were excluded is not defined',
    FluentIdentificationOptionScenario4Empty: '"Do the most desirable" scenario is not defined',
    FluentInvestmentCommentEmpty: 'State and explain all additional information about the above that you consider necessary for readiness assessment, relating to the technical aspect of the project is not defined',
    FluentActivityInfrastructureTextEmpty: 'Whether an architectural competition was conducted in accordance with the law governing planning and construction is not defined',
    FluentActivityInfrastructureDateEmpty: 'Whether an architectural competition was conducted in accordance with the law governing planning and construction - Activity completion date is not defined',
    FluentActivityInfrastructureText2Empty: 'Land acquisition (Formally available land) is not defined',
    FluentActivityInfrastructureDate2Empty: 'Land acquisition (Formally available land) - Document preparation date is not defined',
    FluentActivityCompletionDateInfrastructure2Empty: 'Land acquisition (Formally available land) - Activity completion date is not defined',
    FluentActivityInfrastructureText3Empty: 'Feasibility/justification study is not defined',
    FluentActivityInfrastructureDate3Empty: 'Feasibility/justification study - Activity completion date is not defined',
    FluentActivityInfrastructureText4Empty: 'Preliminary feasibility study (if required) is not defined',
    FluentActivityInfrastructureDate4Empty: 'Preliminary feasibility study (if required) - Activity completion date is not defined',
    FluentActivityInfrastructureText5Empty: 'Institute for Protection of Cultural Monuments approval (if required) is not defined',
    FluentActivityInfrastructureDate5Empty: 'Institute for Protection of Cultural Monuments approval (if required) - Activity completion date is not defined',
    FluentActivityInfrastructureText6Empty: 'Environmental impact assessment (if required) is not defined',
    FluentActivityInfrastructureDate6Empty: 'Environmental impact assessment (if required) - Activity completion date is not defined',
    FluentActivityInfrastructureText7Empty: 'General project is not defined',
    FluentActivityInfrastructureDate7Empty: 'General project - Activity completion date is not defined',
    FluentActivityInfrastructureText8Empty: 'Conceptual design is not defined',
    FluentActivityInfrastructureDate8Empty: 'Conceptual design - Activity completion date is not defined',
    FluentActivityInfrastructureText9Empty: 'Preliminary project is not defined',
    FluentActivityInfrastructureDate9Empty: 'Preliminary project - Activity completion date is not defined',
    FluentActivityInfrastructureText10Empty: 'Building permit is not defined',
    FluentActivityInfrastructureCreationDate10Empty: 'Building permit - Activity completion date is not defined',
    FluentActivityInfrastructureText11Empty: 'Project for execution is not defined',
    FluentActivityInfrastructureDate11Empty: 'Project for execution - Activity completion date is not defined',
    FluentActivityInfrastructureText12Empty: 'Tender documentation is not defined',
    FluentActivityInfrastructureDate12Empty: 'Tender documentation - Activity completion date is not defined',
    FluentActivityInfrastructureText13Empty: 'Tender documentation is not defined',
    FluentActivityInfrastructureDate13Empty: 'Tender documentation - Activity completion date is not defined',
    FluentActivityInfrastructureText14Empty: 'Procurement is part of a broader program is not defined',
    FluentActivityInfrastructureDate14Empty: 'Procurement is part of a broader program - Activity completion date is not defined',
    FluentActivityInfrastructureChoice14Empty: 'Procurement is part of a broader program is not defined',
    FluentInstitutionalChoiceEmpty: 'Investor or other competent authority has been designated is not defined',
    FluentInstitutionalTextEmpty: 'Investor or other competent authority has been designated is not defined - State which is not defined',
    FluentInstitutionalChoice2Empty: 'Public-private partnership (if applicable) is not defined',
    FluentInstitutionalText2Empty: 'Public-private partnership (if applicable) - State which is not defined',
    FluentInstitutionalChoice3Empty: 'Cross-border cooperation exists is not defined',
    FluentInstitutionalText3Empty: 'Cross-border cooperation exists - Describe what type of coordination exists between countries and/or with the project manager is not defined',
    FluentInstitutionalChoice4Empty: 'Existing Project Implementation Unit - PIU / Project Implementation Partnership is not defined',
    FluentInstitutionalText4Empty: 'Existing Project Implementation Unit - PIU / Project Implementation Partnership - State which is not defined',
    FluentInstitutionalChoice5Empty: 'New Project Implementation Unit/partnership established is not defined',
    FluentInstitutionalText5Empty: 'New Project Implementation Unit/partnership established - State which is not defined',
    FluentInstitutionalChoice6Empty: 'Staff engaged (outside PIU) with experience of project user responsible for operations is not defined',
    FluentInstitutionalText6Empty: 'Staff engaged (outside PIU) with experience of project user responsible for operations - State which is not defined',
    FluentInstitutionalChoice7Empty: 'Existing regional/local authority or partner consortium is the project operator is not defined',
    FluentInstitutionalText7Empty: 'Existing regional/local authority or partner consortium is the project operator - State which is not defined',
    FluentInstitutionalChoice8Empty: 'New project user responsible for operational period is not defined',
    FluentInstitutionalText8Empty: 'New project user responsible for operational period - State which is not defined',
    FluentInstitutionalListActivityCommentEmpty: 'Provide clarifications or additional information on the above if you consider it necessary is not defined',
    FluentContextChoiceEmpty: 'Expended funds for project preparation - Amount is not defined',
    FluentContextTextEmpty: 'Expended funds for project preparation - Comment is not defined',
    FluentContextChoice2Empty: 'Estimated project realization costs - Amount is not defined',
    FluentContextText2Empty: 'Estimated project realization costs - Comment is not defined',
    FluentContextChoice3Empty: 'Estimated total project costs (preparation + realization/construction) - Amount is not defined',
    FluentContextText3Empty: 'Estimated total project costs (preparation + realization/construction) - Comment is not defined',
    FluentContextChoice4Empty: '% of costs financed through grant - Amount is not defined',
    FluentContextText4Empty: '% of costs financed through grant - Comment is not defined',
    FluentContextChoice5Empty: '% of costs secured through loan - Amount is not defined',
    FluentContextText5Empty: '% of costs secured through loan - Comment is not defined',
    FluentContextChoice6Empty: 'Borrowing capacity (creditworthiness) of infrastructure owner/operator - Amount is not defined',
    FluentContextText6Empty: 'Borrowing capacity (creditworthiness) of infrastructure owner/operator - Comment is not defined',
    FluentContextChoice7Empty: 'Estimated value of operating costs - Amount is not defined',
    FluentContextText7Empty: 'Estimated value of operating costs - Comment is not defined',
    FluentContextChoice8Empty: 'Estimated Internal Rate of Return (if available) - Amount is not defined',
    FluentContextText8Empty: 'Estimated Internal Rate of Return (if available) - Comment is not defined',
    FluentPlanedDatesPublicInvitationStartEmpty: 'Public procurement call - Target start date',
    FluentPlanedDatesPublicInvitationEndEmpty: 'Public procurement call - Target completion date',
    FluentPlanedDatesAwardContractStartEmpty: 'Contract award - Target start date',
    FluentPlanedDatesAwardContractEndEmpty: 'Contract award - Target completion date',
    FluentPlanedDatesStartWorksStartEmpty: 'Start of works/realization - Target start date',
    FluentPlanedDatesStartWorksEndEmpty: 'Start of works/realization - Target completion date',
    FluentPlanedDatesCompletionWorksStartEmpty: 'Completion of works/realization - Target start date',
    FluentPlanedDatesCompletionWorksEndEmpty: 'Completion of works/realization - Target completion date',
    FluentPlanedDatesProjectOperationalStartEmpty: 'Project becomes operational - Target start date',
    FluentPlanedDatesProjectOperationalEndEmpty: 'Project becomes operational - Target completion date',
    FluentSocioEconomicContextFinancialCommentEmpty: 'State clarifications/additional information about the above that you consider necessary is not defined',
    FluentCapitalRequirementsCapitalsEmpty: 'Estimated costs for each year of project realization in relation to planned project realization timeframe is not defined',
    FluentCapitalRequirementsCapitalsYearEmpty: 'Estimated costs for each year of project realization in relation to planned project realization timeframe - Fiscal year is not defined',
    FluentCapitalRequirementsCapitalsAmountEmpty: 'Estimated costs for each year of project realization in relation to planned project realization timeframe - Amount is not defined',
    FluentCapitalRequirementsRiskInRangeOfConstructionPeriodInvalid: 'Estimated costs for each year - number of years does not match the estimated project duration in months',
    FluentFoundingSourceEmpty: 'Planned funding sources are not defined',
    FluentFoundingSourceAmountEmpty: 'Planned funding sources - Amount in RSD is not defined',
    FluentFoundingSourceCurrencyEmpty: 'Planned funding sources - Currency is not defined',
    FluentFoundingSourceGuaranteedAmountEmpty: 'Planned funding sources - Secured is not defined',
    FluentAirQualityConstructionPhaseEmpty: 'Air quality - Construction phase',
    FluentAirQualityWorkPhaseEmpty: 'Air quality - Operation phase',
    FluentWaterQualityConstructionPhaseEmpty: 'Water quality - Construction phase',
    FluentWaterQualityWorkPhaseEmpty: 'Water quality - Operation phase',
    FluentLandscapeConstructionPhaseEmpty: 'Landscape - Construction phase',
    FluentLandscapeWorkPhaseEmpty: 'Landscape - Operation phase',
    FluentNoiseConstructionPhaseEmpty: 'Noise - Construction phase',
    FluentNoiseWorkPhaseEmpty: 'Noise - Operation phase',
    FluentSoilConstructionPhaseEmpty: 'Soil - Construction phase',
    FluentSoilWorkPhaseEmpty: 'Soil - Operation phase',
    FluentGroundwaterConstructionPhaseEmpty: 'Groundwater - Construction phase',
    FluentGroundwaterWorkPhaseEmpty: 'Groundwater - Operation phase',
    FluentFloraFaunaConstructionPhaseEmpty: 'Flora and fauna - Construction phase',
    FluentFloraFaunaWorkPhaseEmpty: 'Flora and fauna - Operation phase',
    FluentEnvironmentChoiceEmpty: 'Whether the designed infrastructure affects ecologically sensitive areas (Natura 2000 etc.) is not defined',
    FluentEnvironmentCommentEmpty: 'Whether the designed infrastructure affects ecologically sensitive areas (Natura 2000 etc.) - Comment is not defined',
    FluentEnvironmentChoice3Empty: 'Whether the designed infrastructure contributes to climate change mitigation or adaptation is not defined',
    FluentEfficiencyDegreeEmpty: 'Energy efficiency - Increase in energy efficiency degree in case of reconstruction is not defined',
    FluentEfficiencyMinimumEmpty: 'Energy efficiency - Increase in energy efficiency degree in case of reconstruction is not defined',
    FluentEfficiencyOtherEmpty: 'Energy efficiency - Increase in energy efficiency degree in case of reconstruction is not defined',
    FluentEnvironmentComment2Empty: 'State clarifications/additional information about the above that you consider necessary is not defined',
    FluentProjectRisksEmpty: 'Data on preliminary project risks is not defined',
    FluentProjectRisksRiskEmpty: 'Data on preliminary project risks - Risk is not defined',
    FluentProjectRisksResponsibleEmpty: 'Data on preliminary project risks - Person responsible for the risk is not defined',
    FluentProjectRisksProbabilityEmpty: 'Data on preliminary project risks - Probability of risk realization is not defined',
    FluentProjectRisksMeasuresEmpty: 'Data on preliminary project risks - Mitigation/avoidance/confrontation measures are not defined',
    FluentConciseSummaryEmpty: 'Concise overview (summary) of listed data with the authorized proposer\'s preliminary assessment of the project\'s readiness level is not defined',
    FluentProjectIdentificationEmpty: 'Preliminary assessment - Project identification',
    FluentTechnicalAspectEmpty: 'Preliminary assessment - Technical aspect',
    FluentInstitutionalFrameworkEmpty: 'Preliminary assessment - Institutional framework',
    FluentFinancialAspectEmpty: 'Preliminary assessment - Economic-financial aspect',
    FluentEnvironmentalAssessmentEmpty: 'Preliminary assessment - Environmental impact assessment',
    FluentPreliminaryRisksEmpty: 'Preliminary assessment - Preliminary risks',
    FluentResponsiblePeopleEmpty: 'Responsible or authorized contact persons',
    FluentAdminFinancialOpinionEmpty: 'Opinion on the financial and implementation aspect of the project',
    FluentPublicInvitationEmpty: 'Link to development planning documents and/or public policy documents',
    FluentProjectRelevanceEmpty: 'Project relevance is not defined',
    FluentActivityChoiceEmpty: 'Whether an architectural competition was conducted in accordance with the law governing planning and construction is not defined',
    FluentActivityCompletionDateEmpty: 'Whether an architectural competition was conducted in accordance with the law governing planning and construction - activity completion date is not defined',
    FluentActivityCreationDateDocumentEmpty: 'Whether an architectural competition was conducted in accordance with the law governing planning and construction - document preparation date',
    FluentActivityChoice2Empty: 'Land acquisition (Formally available land) is not defined',
    FluentActivityCompletionDate2Empty: 'Land acquisition (Formally available land) - activity completion date is not defined',
    FluentActivityCreationDateDocument2Empty: 'Land acquisition (Formally available land) - document preparation date is not defined',
    FluentActivityChoice3Empty: 'Preliminary justification study (if required) is not defined',
    FluentValidateActivityChoice3Empty: 'Service performed by idea Proposer with other government bodies is required',
    FluentActivityCompletionDate3Empty: 'Preliminary justification study (if required) - activity completion date is not defined',
    FluentActivityCreationDateDocument3Empty: 'Preliminary justification study (if required) - document preparation date is not defined',
    FluentActivityChoice4Empty: 'Justification study is not defined',
    FluentActivityCompletionDate4Empty: 'Justification study - activity completion date is not defined',
    FluentActivityCreationDateDocument4Empty: 'Justification study - document preparation date is not defined',
    FluentActivityChoice5Empty: 'Institute for Protection of Cultural Monuments approval (if required) is not defined',
    FluentActivityCompletionDate5Empty: 'Institute for Protection of Cultural Monuments approval (if required) - activity completion date is not defined',
    FluentActivityCreationDateDocument5Empty: 'Institute for Protection of Cultural Monuments approval (if required) - document preparation date is not defined',
    FluentActivityChoice6Empty: 'Environmental impact assessment (if required) is not defined',
    FluentActivityCompletionDate6Empty: 'Environmental impact assessment (if required) - activity completion date is not defined',
    FluentActivityCreationDateDocument6Empty: 'Environmental impact assessment (if required) - document preparation date is not defined',
    FluentActivityChoice7Empty: 'General project is not defined',
    FluentActivityCompletionDate7Empty: 'General project - activity completion date is not defined',
    FluentActivityCreationDateDocument7Empty: 'General project - document preparation date is not defined',
    FluentActivityChoice8Empty: 'Conceptual design is not defined',
    FluentActivityCompletionDate8Empty: 'Conceptual design - activity completion date is not defined',
    FluentActivityCreationDateDocument8Empty: 'Conceptual design - document preparation date is not defined',
    FluentActivityChoice9Empty: 'Preliminary project is not defined',
    FluentActivityCompletionDate9Empty: 'Preliminary project - activity completion date is not defined',
    FluentActivityCreationDateDocument9Empty: 'Preliminary project - document preparation date is not defined',
    FluentActivityChoice10Empty: 'Project for building permit is not defined',
    FluentActivityCompletionDate10Empty: 'Project for building permit - activity completion date is not defined',
    FluentActivityCreationDateDocument10Empty: 'Project for building permit - document preparation date is not defined',
    FluentActivityChoice11Empty: 'Building permit is not defined',
    FluentActivityCompletionDate11Empty: 'Building permit - activity completion date is not defined',
    FluentActivityCreationDateDocument11Empty: 'Building permit - document preparation date is not defined',
    FluentActivityChoice12Empty: 'Project for execution is not defined',
    FluentActivityCompletionDate12Empty: 'Project for execution - activity completion date is not defined',
    FluentActivityCreationDateDocument12Empty: 'Project for execution - document preparation date is not defined',
    FluentActivityChoice13Empty: 'Tender documentation is not defined',
    FluentActivityCompletionDate13Empty: 'Tender documentation - activity completion date is not defined',
    FluentActivityCreationDateDocument13Empty: 'Tender documentation - activity completion date is not defined',
    FluentPlanningDocumentationActivityTextEmpty: 'Whether an architectural competition was conducted in accordance with the law governing planning and construction - Comment is not defined',
    FluentPlanningDocumentationActivityText2Empty: 'Land acquisition (Formally available land) - Comment is not defined',
    FluentPlanningDocumentationActivityText3Empty: 'Preliminary justification study (if required) - Comment is not defined',
    FluentPlanningDocumentationActivityText4Empty: 'Justification study - Comment is not defined',
    FluentPlanningDocumentationActivityText5Empty: 'Institute for Protection of Cultural Monuments approval (if required) - Comment is not defined',
    FluentPlanningDocumentationActivityText6Empty: 'Environmental impact assessment (if required) - Comment is not defined',
    FluentPlanningDocumentationActivityText7Empty: 'General project - Comment is not defined',
    FluentPlanningDocumentationActivityText8Empty: 'Conceptual design - Comment is not defined',
    FluentPlanningDocumentationActivityText9Empty: 'Preliminary project - Comment is not defined',
    FluentPlanningDocumentationActivityText10Empty: 'Project for building permit - Comment is not defined',
    FluentPlanningDocumentationActivityText11Empty: 'Building permit - Comment is not defined',
    FluentPlanningDocumentationActivityText12Empty: 'Project for execution - Comment is not defined',
    FluentPlanningDocumentationActivityText13Empty: 'Tender documentation - Comment is not defined',
    FluentPlanCompatibilityPublicInvitationEmpty: 'Link to development planning documents and/or public policy documents',
    FluentPlanCompatibilityProjectRelevanceEmpty: 'Project relevance is not defined',
    FluentPlanCompatibilityStartEmpty: 'Estimated realization start year',
    FluentPlanCompatibilityEndEmpty: 'Estimated realization completion year is not defined is not defined',
    FluentImportantFinancialCommentEmpty: 'State clarifications/additional information about the above that you consider necessary is not defined is not defined',
    FluentImportantProjectReadinessEmpty: 'Comment for project readiness assessment is missing',
    FluentImportantProjectReadinessAssessmentEmpty: 'Readiness level in the readiness assessment is not defined (point 6)',
    FluentEmptyImplementationComment: 'Comment of the authorized capital project proposer must be filled in',
    FluentStartEmpty: '"Estimated realization start year" must be filled in',
    FluentEndEmpty: '"Estimated realization completion year" must be filled in',
    UnRetrievePagedProjects: 'Unknown error retrieving project list',
    UnRetrievePagedProjectDocuments: 'Unknown error retrieving document list',
    UnRetrieveProjectDocument: 'Unknown error retrieving document',
    UnProjectCreate: 'Unknown error creating project',
    UnUpdateProject: 'Unknown error updating project',
    UnProjectPhaseStatusUpdate: 'Unknown error updating phase status',
    UnProjectPhaseUpdate: 'Unknown error updating phase',
    UnRetrieveProject: 'Unknown error retrieving project',
    UnRetrieveForm: 'Unknown error retrieving form',
    UnUploadProjectDocument: 'Unknown error uploading document',
    UnUpdateProjectDocumentRevision: 'Unknown error updating secured link',
    UnSubmitProjectForm: 'Unknown error updating form',
    UnEvaluateProjectForm: 'Unknown error evaluating form',
    UnRetrieveProjectPhases: 'Unknown error retrieving project stages',
    UnRetrieveProjectOrganizations: 'Unknown error retrieving organizations',
    UnSetProjectOrganizations: 'Unknown error updating organizations',
    UnCreateProjectList: 'Unknown error sending list to commission',
    UnRetrieveProjectLists: 'Unknown error retrieving project list',
    UnRetrieveProjectList: 'Unknown error retrieving project list details',
    UnSetProjectAppropriations: 'Unknown error updating appropriations',
    UnRetrieveProjectAppropriations: 'Unknown error retrieving project appropriations',
    UnUploadProjectDocumentRevision: 'Unknown error uploading document revision',
    UnRetrieveProjectDocumentRevisions: 'Unknown error retrieving document revisions',
    UnRemoveProjectDocument: 'Unknown error deleting document',
    UnRetrieveProjectSuccessKeyIndicators: 'Unknown error retrieving KPI data',
    DbRetrievePagedProjects: 'Error retrieving project list',
    DbRetrievePagedProjectDocuments: 'Error retrieving document list',
    DbRetrieveProjectDocument: 'Error retrieving document. Requested document does not exist',
    DbRetrieveProjectDocuments: 'Error retrieving project documents',
    DbProjectCreate: 'Error creating project',
    DbProjectPhaseStatusUpdate: 'Error updating phase status',
    DbProjectPhaseUpdate: 'Error updating phase',
    DbRetrieveProject: 'Error retrieving project',
    DbRetrieveForm: 'Error retrieving form',
    DbCreateProjectForm: 'Error creating project form',
    DbSubmitProjectForm: 'Error updating project form',
    DbEvaluateProjectForm: 'Error evaluating project form',
    DbRetrieveProjectForm: 'Error retrieving project form',
    DbUploadProjectDocument: 'Error uploading document',
    DbUpdateProjectDocumentRevision: 'Error updating secured link',
    DbRetrieveProjectPhases: 'Error retrieving project stages',
    DbRetrieveProjectOrganizations: 'Error retrieving organizations',
    DbSetProjectOrganizations: 'Error updating organizations',
    DbAddProjectOrganziationInvalidState: 'Error adding organization. Organization already exists',
    DbRemoveProjectOrganziationInvalidState: 'Error deleting organization. Organization does not exist',
    DbRetrieveProjectLists: 'Error retrieving project list',
    DbRetrieveProjectList: 'Error retrieving project list details',
    DbCreateProjectList: 'Error sending list to commission',
    DbAddProjectAppropriationInvalidState: 'Error adding appropriation. Appropriation already exists',
    DbRemoveProjectAppropriationInvalidState: 'Error deleting appropriation. Appropriation does not exist',
    DbSetProjectAppropriations: 'Error updating appropriations',
    DbRetrieveProjectAppropriations: 'Error retrieving project appropriations',
    DbRetrieveProjectFormData: 'Error retrieving form data',
    DbRetrieveProjectDocumentRevision: 'Error retrieving document revision. Requested document does not exist',
    DbUploadProjectDocumentRevision: 'Error uploading document revision',
    DbRetrieveProjectDocumentRevisions: 'Error retrieving document revisions',
    DbSetProjectDocumentDownload: 'Error updating document download information',
    DbRemoveProjectDocument: 'Error deleting document',
    DbRemoveProjectDocumentRevisions: 'Error deleting document revisions',
    DbRetrieveFormsUsingDocument: 'Error retrieving forms using document',
    DbRetrieveProjectSuccessKeyIndicators: 'Error retrieving KPI data',
    DbRetrieveProjectListReport: 'Error retrieving project list for report generation',
    DbRetrieveProjectSummaryReport: 'Error retrieving summary project list for report generation',
    DbRetrieveProjectsRealizedReport: 'Error retrieving realized projects for report generation',
    DbRetrieveProjectsInRealizationReport: 'Error retrieving projects in realization for report generation',
    DbRetrieveProjectsBoardAcceptedReport: 'Error retrieving commission-approved projects',
    TranUploadProjectDocument: 'Transaction error uploading document',
    TranUpdateProjectDocumentRevision: 'Transaction error updating secured link',
    TranUnCreateProject: 'Transaction error creating project',
    TranUnUpdateProject: 'Transaction error updating project',
    TranExistsProjectCode: 'A project with the entered working name already exists',
    InvalidExportFormat: 'Export format is not valid',
    UnExportForm: 'Unknown error during export',
    DuplicateRegistryOrganization: 'Duplicate organization identifier found',
    EmptyRegistryImportOrganizationPayload: 'Organization code book import request is not valid',
    UnImportRegistryOrganization: 'Unknown error importing organization code book',
    UnRetrievePagedRegistryOrganization: 'Unknown error retrieving organization code book',
    DbRetrievePagedRegistryOrganization: 'Error retrieving organization code book',
    DbImportRegistryOrganizationInvalidState: 'Error importing organization code book',
    DbImportRegistryOrganization: 'Error importing organization code book',
    DuplicateRegistryTreasuryBranch: 'Duplicate treasury branch identifier found',
    EmptyImportRegistryTreasuryBranchPayload: 'Treasury branch code book import request is not valid',
    UnRetrievePagedRegistryTreasuryBranch: 'Unknown error retrieving treasury branch code book',
    UnImportRegistryTreasuryBranch: 'Unknown error importing treasury branch code book',
    UnRetrieveRegistryTreasuryBranch: 'Unknown error retrieving treasury branch',
    UnRetrieveRegistryTreasuryBranches: 'Unknown error retrieving treasury branch code book',
    DbImportRegistryTreasuryBranch: 'Error importing treasury branch code book',
    DbImportRegistryTreasuryBranchInvalidState: 'Error importing treasury branch code book',
    DbRetrieveRegistryTreasuryBranch: 'Error retrieving treasury branch',
    DbRetrieveRegistryTreasuryBranches: 'Error retrieving treasury branch code book',
    DuplicateRegistryAppropriation: 'Duplicate appropriation identifier found',
    EmptyRegistryImportAppropriationPayload: 'Appropriation code book import request is not valid',
    UnImportRegistryAppropriation: 'Unknown error importing appropriation code book',
    UnRetrieveRegistryAppropriations: 'Unknown error retrieving appropriation code book',
    DbImportRegistryAppropriationInvalidState: 'Error importing appropriation code book',
    DbImportRegistryAppropriation: 'Error importing appropriation code book',
    DbRetrieveRegistryAppropriations: 'Error retrieving appropriation code book',
    InvalidOrganizationPermission: 'User does not have organization permissions',
    EmptyRetrieveRegistrationRequestBody: 'Request to retrieve organizations is not valid',
    EmptyResolveRegistrationRequestBody: 'Request to process registrations is not valid',
    EmptyUpdateRegistrationMaxAmountBody: 'Request to update maximum amount on organization is not valid',
    EmptyUpdateRegistrationBody: 'Request to update organization is not valid',
    AlreadySubmittedRegistration: 'Organization is already registered',
    InvalidRegistrationBudgetUserId: 'Organization JBKJS does not match',
    InvalidRegistrationStatus: 'Registration status is not valid. Must be pending',
    RegistrationConfirmationMail: 'Error sending registration email',
    ForbiddenOrganizationRegistration: 'Registration is not allowed',
    InvalidOrganizationIdValidation: 'Organization identifier is not valid',
    InvalidOrganizationAdminNameValidation: 'Administrator name is not valid',
    InvalidOrganizationAdminIdentityNumberValidation: 'Administrator identity document number is not valid',
    InvalidOrganizationAdminEmailValidation: 'Administrator email address is not valid',
    InvalidOrganizationAdminPhoneNumberValidation: 'Administrator phone number is not valid',
    InvalidRegistrationTokenValidation: 'Token is not valid',
    InvalidOrganizationRequestRespondValidation: 'Request response is not valid',
    InvalidOrganizationRequestCommentValidation: 'Comment is not valid',
    InvalidOrganizationMaxAmountValidation: 'Maximum amount is not valid',
    InvalidOrganizationAdminLoginValidation: 'Administrator username is not valid',
    InvalidOrganizationEmailValidation: 'Email address is not valid',
    InvalidOrganizationPhoneNumberValidation: 'Phone number is not valid',
    InvalidSupportEmailsValidation: 'Support email address is not valid',
    InvalidSupportPhoneNumbersValidation: 'Support phone number is not valid',
    ExceededSupportEmailsLimitValidation: 'Allowed number of support email addresses exceeded. Three email addresses allowed',
    ExceededSupportPhoneNumbersLimitValidation: 'Allowed number of support phone numbers exceeded. Three phone numbers allowed',
    EmptyOrganizationNameShortValidation: 'Short name is required',
    InvalidOrganizationNameShortLengthValidation: 'Short name length is not valid',
    InvalidOrganizationNameShortValidation: 'Short name may contain only letters',
    UnDecryptRegistrationToken: 'Unknown error decrypting token',
    UnApproveRegistrationRequest: 'Unknown error approving registration',
    UnCancelRegistrationRequest: 'Unknown error cancelling registration',
    UnCreateRegistrationRequest: 'Unknown error creating registration',
    UnUpdateRegistrationRequest: 'Unknown error updating registration',
    UnValidateRegistration: 'Unknown error retrieving registration',
    UnRetrievePagedRegistration: 'Unknown error retrieving registrations',
    UnRetrieveRegistration: 'Unknown error retrieving registration',
    UnRetrieveRegistrationRequest: 'Unknown error retrieving registrations',
    UnUpdateRegistrationMaxAmount: 'Unknown error updating maximum amount on organization',
    UnUpdateRegistration: 'Unknown error updating organization',
    DbRetrieveBudgetUser: 'Error retrieving KJS',
    DbRetrievePagedOrganization: 'Error retrieving organizations',
    DbCreateRegistrationRequest: 'Error creating registration',
    DbRetrieveRegistration: 'Error retrieving registration',
    DbRetrieveTreasuryBranch: 'Error retrieving treasury branch',
    DbDecryptRegistrationToken: 'Error decrypting token',
    DbApproveRegistrationRequest: 'Error approving registration',
    DbCreateInitialUser: 'Error creating initial organization user',
    DbCancelRegistrationRequest: 'Error cancelling registration',
    DbUpdateRegistrationRequest: 'Error updating registration',
    DbUpdateRegistrationMaxAmount: 'Error updating maximum amount on organization',
    DbUpdateRegistration: 'Error updating organization',
    TranUnApproveRegistration: 'Error approving registration',
    TranUnRegistrationUpdate: 'Error updating registration',
    TranCreateInitialUserLoginExists: 'Username already exists',
    TranCreateInitialUserRoleInvalid: 'Initial user role is not valid',
    TranCreateInitialUser: 'Error creating initial organization user',
    InvalidRoleClaims: 'Unable to validate all permissions for the role',
    InvalidRole: 'Role is not valid',
    UpdateSystemRole: 'System role cannot be updated',
    DeleteSystemRole: 'System role cannot be deleted',
    DeleteRole: 'Role cannot be deleted if it belongs to a user',
    InvalidRoleIdValidation: 'Role identifier is not valid',
    InvalidRoleNameValidation: 'Role name is not valid',
    InvalidRoleDescriptionValidation: 'Role description is not valid',
    InvalidClaimNameValidation: 'Permission name is not valid',
    InvalidClaimsValidation: 'Permissions are not valid',
    UnCreateRole: 'Unknown error creating role',
    UnUpdateRole: 'Unknown error updating role',
    UnDeleteRole: 'Unknown error deleting role',
    UnClaimsRetrieve: 'Unknown error retrieving permissions',
    UnRolesRetrieve: 'Unknown error retrieving roles',
    UnRetrieveRole: 'Unknown error retrieving role',
    DbCreateRole: 'Error creating role',
    DbCreateRoleInvalidState: 'Error creating role. Role with given name already exists',
    DbUpdateRole: 'Error updating role',
    DbUpdateRoleInvalidState: 'Error updating role. Role with given name already exists',
    DbDeleteRole: 'Error deleting role',
    DbDeleteRoleInvalidState: 'Error deleting role. Role likely belongs to a user',
    DbRetrieveUserClaims: 'Error retrieving user permissions',
    DbRetrieveRoles: 'Error retrieving roles',
    DbRetrieveRole: 'Error retrieving role',
    TranUnCreateRole: 'Error creating role',
    TranUnUpdateRole: 'Error updating role',
    TranUnDeleteRole: 'Error deleting role',
    TranCreateRole: 'Role with given name already exists',
    TranUpdateRole: 'Invalid role identifier',
    TranDeleteRole: 'Role belongs to a user and cannot be deleted',
    TranCreateRoleClaims: 'Error creating user permissions',
    TranDeleteRoleClaims: 'Error updating user permissions',
    InvalidUser: 'User not found',
    InvalidUserPassword: 'Username or password are incorrect',
    InvalidUserAccess: 'Username or password are incorrect or user is not in active status',
    InvalidRefreshToken: 'Token is invalid or revoked',
    InactiveUser: 'User is not active',
    RevokedUser: 'User is revoked',
    DisabledUser: 'User is deactivated',
    UpdateUserItselfStatus: 'Personal permission assignment is not possible',
    UpdateDisabledUserStatus: 'Attempt to update deactivated user',
    UpdateRevokedUserStatus: 'Attempt to update revoked user',
    UpdateInactiveUserStatus: 'Attempt to update inactive user',
    UpdateSameUserStatus: 'Attempt to update user with status they already have',
    AlreadyActivatedUser: 'User is already activated',
    DeactivatedUser: 'User is deactivated',
    MismatchActivationTokenUser: 'Activation token is not valid for user',
    MismatchResetTokenUser: 'Reset token is not valid for user',
    PasswordResetUserStatus: 'Cannot reset password for inactive user',
    DuplicateUserLogin: 'Duplicate username found',
    InvalidLoginCharacters: 'Username cannot be empty or longer than 32 characters',
    UpdateUserPasswordPermission: 'Only the user themselves can change their password',
    UpdateUserProfilePermission: 'Only the user themselves can update their profile',
    RetrieveUserPermission: 'User does not have permission to view the user',
    UpdateMultipleOrganizationUsers: 'Cannot update users from multiple organizations',
    DuplicateUserTag: 'Duplicate tag found',
    ReachedUserTagsLimit: 'Allowed number of tags per user exceeded',
    InvalidUserTag: 'User tag not found',
    UserActivationMail: 'Error sending activation email',
    UserPasswordResetMail: 'Error sending email for new user location verification',
    ReachedFailedLoginAttemptCount: 'User is locked due to exceeded number of failed login attempts',
    InvalidActivationToken: 'Activation token is not valid',
    InvalidResetToken: 'Password reset token is not valid',
    ExistsMergeUser: 'User is already merged',
    InvalidMergedUser: 'Cannot associate currently logged in user',
    InvalidUnmergedUser: 'Cannot separate currently logged in user',
    BlockedUserLocation: 'Unknown location detected. Login is not possible until the new location is verified. Details have been sent to your email address',
    BlockedUser: 'User is blocked due to suspicious activities. Contact the system administrator',
    InvalidPasswordLengthValidation: 'Password character count is incorrect',
    InvalidPasswordNumbersValidation: 'Password must contain a number',
    InvalidPasswordUppercaseValidation: 'Password must contain an uppercase letter',
    InvalidPasswordSymbolsValidation: 'Password must contain symbols',
    InvalidPasswordValidation: 'Password is not valid',
    InvalidNewPasswordValidation: 'Password confirmation is not valid',
    InvalidUserStatusValidation: 'Status is not valid',
    InvalidUserLoginLengthValidation: 'Username length is not valid',
    InvalidUserLoginValidation: 'Username is not valid',
    InvalidUserLoginPrefixValidation: 'Username must start with a letter or number',
    InvalidUserLoginSufixValidation: 'Username must end with a letter or number',
    InvalidUserLoginCharacterValidation: 'Username contains disallowed characters',
    InvalidUserNameLengthValidation: 'Name length is not valid',
    InvalidUserNameValidation: 'Name is not valid',
    InvalidUserNamePrefixValidation: 'Name must start with a letter or number',
    InvalidUserNameSufixValidation: 'Name must end with a letter or number',
    InvalidUserNameCharacterValidation: 'Name contains disallowed characters',
    InvalidUserEmailValidation: 'Email is not valid',
    InvalidUserRoleIdValidation: 'Role identifier is not valid',
    InvalidUserCreatedDateValidation: 'Creation date is not valid',
    UnUpdateUserPassword: 'Unknown error updating password',
    UnUpdateUserStatus: 'Unknown error updating user status',
    UnUpdateUser: 'Unknown error updating user',
    UnUpdateUserProfile: 'Unknown error updating user profile',
    UnCreateAccessToken: 'Unknown error creating access token',
    UnRefreshAccessToken: 'Unknown error creating refresh token',
    UnRetrievePagedUsers: 'Unknown error retrieving users',
    UnCreateUser: 'Unknown error creating user',
    UnRetrieveUser: 'Unknown error retrieving user',
    UnRetrieveUniqueUserLogin: 'Unknown error retrieving unique username',
    UnCreateActivationToken: 'Unknown error creating activation token',
    UnCreateResetToken: 'Unknown error creating reset token',
    UnActivateUser: 'Unknown error activating user',
    UnValidateActivationToken: 'Unknown error validating user activation',
    UnValidateResetToken: 'Unknown error validating password reset token',
    UnResetUserPassword: 'Unknown error resetting user password',
    UnSetUserTag: 'Unknown error setting tag',
    UnSetSelectonTag: 'Unknown error setting selection',
    UnMergeUser: 'Unknown error merging user',
    UnUnmergeUser: 'Unknown error separating merged users',
    UnRetrieveMergedUsers: 'Unknown error retrieving merged users',
    UnRetrieveMergedUser: 'Unknown error retrieving merged user',
    UnUpdateUserLastLogoutDate: 'Unknown error updating user last logout date',
    DbRetrieveUser: 'Error retrieving user',
    DbRetrievePagedUsers: 'Error retrieving users',
    DbUpdateUserPassword: 'Error updating password',
    DbCreateUser: 'Error creating user',
    DbCreateUserInvalidState: 'User account taken',
    DbUpdateUserStatus: 'Error updating user status',
    DbUpdateUser: 'Error updating user',
    DbUpdateUserProfile: 'Error updating user profile',
    DbUpdateUserLastLoginDate: 'Error updating last user login date',
    DbUpdateUserLastLogoutDate: 'Error updating last user logout date',
    DbUpdateUserLastRefreshTokenDate: 'Error updating last refresh token date',
    DbRetrieveUserFromActivationToken: 'Error retrieving user from activation token',
    DbActivateUser: 'Error activating user',
    DbUpdateUserInvalidState: 'Error updating user',
    DbUpdateUserStatusInvalidState: 'Error updating user status',
    DbRetrieveUsers: 'Error retrieving users',
    DbManageUserTagInvalidState: 'Error updating tags',
    DbRetrieveTaggedUsers: 'Error retrieving tagged users',
    DbMergeUser: 'Error merging user',
    DbUnmergeUser: 'Error separating merged users',
    DbRetrieveMergedUsers: 'Error retrieving merged users',
    DbRetrieveMergedUser: 'Error retrieving merged user',
    TranUnCreateUser: 'Error creating user',
    TranUnUpdateUser: 'Error updating user',
    TranUnUpdateUserProfile: 'Error updating user profile',
    TranUserLoginExists: 'Username already exists',
    TranCreateUser: 'Error creating user',
    TranUpdateUserHigherPrivileges: 'Error updating user with higher privileges',
    TranUpdateUserForbiddenPermissions: 'Error updating user with forbidden permissions',
    TranRetrieveUserId: 'Error retrieving user by identifier',
    TranUserLimit: 'Allowed number of users per organization exceeded',
    TranDuplicateUserLogin: 'Duplicate username found',
    TranOrganizationNameShortExists: 'Short name already exists',
    RetrieveImportantProjectDocument: 'Document of type "CPPZ Government of RS decision" not entered',
    ErrProjectIdentificationNewCostDocument: 'Source documents not found',
    ErrProjectIdentificationFinacialSourceDocument: '"Letter of intent" document related to point 4.6 not entered',
    ErrProjectIdentificationEstimateCapitalRetrieve: 'If no comment is entered in point 4.1, document CP Proposal - Display of sources for estimating total capital project costs must be attached',
    ErrProjectIdentificationFeasibilitySourceDocument: '"Email exchange" or "Letter of intent of external financier" documents related to point 4.2 not entered',
    ErrProjectIdentificationIsdakonDocument: 'ISDAKON evaluation not entered',
    ErrProjectPreparednessRealizationPlanDocumentRetrieve: 'Framework implementation plan document not entered even though the form states that the plan exists.',
    ErrProjectCorrectionDocument: 'Correction must be accompanied by "Explanation of deviation reasons" and "Evidence for claims in the explanation" documents',
    ErrProjectIdentificationMfinCommentMissing: 'MFIN comment not entered',
    O3ScopeChoiceEmpty: 'Coherent with project objectives - you must select Yes or No',
    O3ScopeChoice2Empty: 'Consistent with development plan objectives - you must select Yes or No',
    O3ScopeChoice3Empty: 'Aligned with regulatory and legal framework - you must select Yes or No',
    O3ScopeChoice4Empty: 'Has a framework implementation plan - you must select Yes or No',
    O3ScopeChoice5Empty: 'Has identified clients/buyers or project users - you must select Yes or No',
    O3ScopeChoice6Empty: 'Has prepared project-tender documentation - you must select Yes or No',
    O3ScopeChoice7Empty: 'Has identified critical project points - you must select Yes or No',
    O3ScopeChoice8Empty: 'Has identified potential risks and problems - you must select Yes or No',
    O3ScopeChoice9Empty: 'Has defined mechanisms for resolving/mitigating potential risks/problems - you must select Yes or No',
    O3ScopeChoice10Empty: 'Has defined human/institutional or material/technical resources needed for project realization - you must select Yes or No',
    O3ScopeChoice11Empty: 'Has a Preliminary feasibility/justification study - you must select Yes or No',
    O3ScopeChoice12Empty: 'Has clearly defined roles and responsibilities - you must select Yes or No',
    O3ProcurementChoiceEmpty: 'Service procurement - you must select Yes or No',
    O3ProcurementChoice2Empty: 'Equipment procurement - you must select Yes or No',
    O3ProcurementChoice3Empty: 'Infrastructure projects/real estate procurement - you must select Yes or No',
    ProcurementChoiceActivityChoiceError31: 'If Service procurement is Yes (point 2), all fields in point 3.1 must be filled in',
    ProcurementChoiceActivityChoiceError32: 'If Equipment procurement is Yes (point 2), all fields in point 3.2 must be filled in',
    ProcurementChoiceActivityChoiceError33: 'If Infrastructure projects/real estate procurement is Yes (point 2), all fields in point 3.3 must be filled in'
  },
  fields: {
    NewPassword: 'New password'
  }
}
